import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
import { CameraModeMask, CameraControl } from '@egr/wcf/modules/core/view/CameraControl';
import { ElementCategory, SceneElement, UndoOperation } from '@egr/wcf/modules/core/mdl';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
import { AdvancedDynamicTexture, TextBlock } from "@babylonjs/gui";
import { Geometry } from "@babylonjs/core//Meshes/geometry";
import { Plane } from "@babylonjs/core/Maths/math.plane";
import { Ray } from "@babylonjs/core/Culling/ray";
import { VertexData } from "@babylonjs/core/Meshes/mesh.vertexData";
import { Quaternion } from "@babylonjs/core/Maths/math.vector";
import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { CreateLines } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { CreateLineSystem } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { CreatePlane } from "@babylonjs/core/Meshes/Builders/planeBuilder";
import { Color3 } from "@babylonjs/core/Maths/math.color";
import { Matrix } from "@babylonjs/core/Maths/math.vector";
import { RayHelper } from "@babylonjs/core/Debug/rayHelper";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { TransformNode } from "@babylonjs/core/Meshes/transformNode";
import { Frustum } from '@babylonjs/core/Maths/math.frustum';
import { WallInteractors } from '../tool/interactors';
import { CsgUtils } from "./CsgUtils";
import { EditWalls } from "../cmd/EditWalls";
import { VisibilityMode } from './../RoomManager';
import { RoomWizard } from "../RoomWizard";
import { Util } from '../utils/Util';
import { WALL_ELEMENT_CLASSID } from './io/Types';
import { WallAddition } from './WallAddition';
import { WallCrossHair } from '../WallCrossHair';
import { WallOpening } from './WallOpening';
import { WallSnapping } from "../tool/WallSnapping";
import { VECTOR3_ZERO, angleBetweenVectors2, VECTOR2_X, signedAngleBetweenVectors2, projectPointOnLine2ToRef, isPointOnSegment2, isParallel2, orientationToLine2, Orientation, perpendicularVector2, intersectLineLine2 } from "@egr/wcf/modules/core/utils/MathUtils";
import { eq, clamp, radToDeg, degToRad, leq, geq } from "@egr/wcf/modules/utils/math";
import { serializeVector2, deserializeVector2 } from "@egr/wcf/modules/core/io";
import { PropertyValue, LengthProperty, PropertyChangedResult, NumberProperty, StringProperty, Color3Property, BoolProperty } from '@egr/wcf/modules/core/prop';
import { getRotationQuaternion, setLocalMatrix, updateFrozenWorldMatrix, resizeInViewSpace } from "@egr/wcf/modules/core/utils/MeshUtils";
import { contains, removeElement } from "@egr/wcf/modules/utils/array";
import { ViewLayerMaskFlags } from "@egr/wcf/modules/core/view/View";
export var WallEnding;
(function (WallEnding) {
    WallEnding[WallEnding["Start"] = 0] = "Start";
    WallEnding[WallEnding["End"] = 1] = "End";
})(WallEnding || (WallEnding = {}));
export var WallSide;
(function (WallSide) {
    WallSide[WallSide["Left"] = 0] = "Left";
    WallSide[WallSide["Right"] = 1] = "Right";
})(WallSide || (WallSide = {}));
/*
*    2D wall structure:
*
*    edge 3-----------------------edge 2
*      |                            |
*    start				           end
*      |                            |
*    edge 0-----------------------edge 1
*/
export class Wall extends SceneElement {
    constructor(pRoomManager, pDrawManually = false) {
        super(pRoomManager.app.model, new TransformNode("room:Wall", pRoomManager.app.model.scene));
        this.onBeforeCameraChanged = () => {
            if (this.mSelectionShape !== null) {
                if (this.isSelected) {
                    if (this.mRoomManager.viewMode === 0) {
                        this.mrenderingGroupId = 0;
                        this.mSelectionShape.renderingGroupId = this.mrenderingGroupId;
                    }
                    if (this.mRoomManager.viewMode === 7 || this.mRoomManager.viewMode === 6) {
                        this.mrenderingGroupId = 1;
                        this.mSelectionShape.renderingGroupId = this.mrenderingGroupId;
                    }
                }
                else if (this.mSelectionShapeActive) {
                    if (this.mRoomManager.viewMode === 0) {
                        this.mrenderingGroupId = 0;
                        this.mSelectionShape.renderingGroupId = this.mrenderingGroupId;
                    }
                    if (this.mRoomManager.viewMode === 7 || this.mRoomManager.viewMode === 6) {
                        this.mrenderingGroupId = 1;
                        this.mSelectionShape.renderingGroupId = this.mrenderingGroupId;
                    }
                }
            }
        };
        this._resizeMeshes = () => {
            this.resizeMeshes();
        };
        // tslint:disable-next-line:cyclomatic-complexity
        this.onAfterCameraChanged = () => {
            if (!this.isSelected)
                return;
            if (this.mSelectionShape !== null) {
                if (this.mRoomManager.app.model.selection.length > 1) {
                    this.mSelectionShape.setEnabled(false);
                    this.mSelectionShape.visibility = 0;
                    this.mSelectionShape.material = this.mRoomManager.wall2dMaterialDarkGrey;
                }
                else {
                    this.mSelectionShape.setEnabled(this.mSelectionShapeActive);
                    this.mSelectionShape.visibility = this.mSelectionShapeActive ? 0.5 : 0;
                    this.mSelectionShape.material = this.mSelectionShapeActive ? this.mRoomManager.wall2dMaterialSelected : this.mRoomManager.wall2dMaterialDarkGrey;
                    if (this.isSelected) {
                        if (this.mRoomManager.viewMode === 0) {
                            this.mrenderingGroupId = 0;
                            this.mSelectionShape.renderingGroupId = this.mrenderingGroupId;
                        }
                        if (this.mRoomManager.viewMode === 7) {
                            this.mrenderingGroupId = 1;
                            this.mSelectionShape.renderingGroupId = this.mrenderingGroupId;
                        }
                    }
                }
                if (!this.m3dWallVisible && !this.isSelected)
                    this.mSelectionShape.setEnabled(false);
            }
        };
        this.mRoomManager = pRoomManager;
        this.mScene = pRoomManager.app.model.scene;
        this.mInteractors = new WallInteractors(this.mRoomManager, this);
        this.mShowInteractor = false;
        this.mInitialCloning = false;
        this.mKeepMesh = new TransformNode("circleArcNode", this.mScene);
        this.mRoomManager.createColorMaterial("#ffffff");
        this.mId = this.mRoomManager._getNextWallId();
        this.mIdStr = Util.HashString();
        this.mStart = new Vector2(0, 0);
        this.mEnd = new Vector2(1, 0);
        this.mHeight = 2.6;
        this.mThickness = 0.24;
        this.mPickPlane = new Plane(0, 0, 0, 0);
        this.mFreeSpace = new Array();
        this.mIsDrawingNew = false;
        this.mMoveMode = WallSnapping.Mode.MoveWall;
        this.misMoving = false;
        this.mSidePolygons = new Array();
        this.mWallSideDummy_R = null;
        this.mWallSideDummy_L = null;
        this.mOpeningIsInteraction = false;
        this.m3dWallVisible = false;
        this.mrenderingGroupId = 0;
        this.mIsInFrustum = false;
        this.mViewTriangle = new Array();
        this.mColorL = this.mRoomManager._wallColors[0];
        this.mColorR = this.mRoomManager._wallColors[0];
        this.mMaterialA = {};
        this.mMaterialA.category = "color";
        this.mMaterialA.value = "#ffffff";
        this.mMaterialA.loadMatId = "";
        this.mMaterialA.rotation = 0;
        this.mMaterialA.idAddOn = this.mRoomManager.materialSplitStr + this.mIdStr + this.mRoomManager.materialSplitStr + "A";
        this.mMaterialB = {};
        this.mMaterialB.category = "color";
        this.mMaterialB.value = "#ffffff";
        this.mMaterialB.loadMatId = "";
        this.mMaterialB.rotation = 0;
        this.mMaterialB.idAddOn = this.mRoomManager.materialSplitStr + this.mIdStr + this.mRoomManager.materialSplitStr + "B";
        this.updateMaterial();
        this.mMatOfCatList_A = new Array();
        this.mMatOfCatList_B = new Array();
        this.mEdges = new Array();
        this.mEdges.push(Vector2.Zero(), Vector2.Zero(), Vector2.Zero(), Vector2.Zero());
        this.mUnCutEdges = new Array();
        this.mUnCutEdges.push(Vector2.Zero(), Vector2.Zero(), Vector2.Zero(), Vector2.Zero());
        this.mLocalEdges = new Array();
        this.mLocalEdges.push(Vector2.Zero(), Vector2.Zero(), Vector2.Zero(), Vector2.Zero());
        this.mCutLines = new Array();
        this.mRayPoints = new Array();
        if (this.mNode != null)
            this.mNode.freezeWorldMatrix();
        this.m2dMeshes = new Array();
        this.m3dMeshes = new Array();
        this.m3dNeedsUpdate = false;
        this.mStartCxn = {};
        this.mStartCxn.wall = null;
        this.mStartCxn.wallEnding = null;
        this.mStartCxn.badCut = false;
        this.mEndCxn = {};
        this.mEndCxn.wall = null;
        this.mEndCxn.wallEnding = null;
        this.mEndCxn.badCut = false;
        this.mMovePoint = null;
        this.mWallSnapped = Wall.WallSnapState.None;
        this.mOpenings = new Array();
        this.mAdditions = new Array();
        this.mRoomElements = new Array();
        this.mVisible = true;
        this.misHidden = false;
        this.mKeepVisible = pDrawManually;
        this.mRay = new Ray(Vector3.Zero(), Vector3.Zero(), 0);
        this.mTransformWallLength = 0;
        this.mHandleTansformationChange = true;
        this.mPendingTransformMatrix = null;
        this.mMaterialLoading = false;
        this.mView = null;
        this.mScaling = new Vector2(1, 1);
        this.mScaleGap = 0;
        this.initEdgeAngleData();
        this.setView();
    }
    get category() {
        return (ElementCategory.Wall);
    }
    get id() {
        return (this.mId);
    }
    get mesh2d() {
        return (this.m2dMeshes);
    }
    get startPoint() {
        return (this.mStart);
    }
    get startCxn() {
        return (this.mStartCxn);
    }
    get endPoint() {
        return (this.mEnd);
    }
    get endCxn() {
        return (this.mEndCxn);
    }
    get wallCenter() {
        return (Vector2.Center(this.mStart, this.mEnd));
    }
    get wallDirection() {
        return ((this.mEnd.subtract(this.mStart)).normalize());
    }
    get thickness() {
        return (this.mThickness);
    }
    get height() {
        return (this.mHeight);
    }
    get PickPlane() {
        return (this.mPickPlane);
    }
    get color_l() {
        return (this.mColorL);
    }
    get color_r() {
        return (this.mColorR);
    }
    get materialSetA() {
        return (this.mMaterialA);
    }
    get materialSetB() {
        return (this.mMaterialB);
    }
    get isVisible() {
        return (this.mVisible);
    }
    get isHidden() {
        return (this.misHidden);
    }
    get keepVisible() {
        return (this.mKeepVisible);
    }
    get isSnapping() {
        return (this.mWallSnapped !== Wall.WallSnapState.None);
    }
    get wallSidePolygons() {
        return (this.mSidePolygons);
    }
    get openings() {
        return (this.mOpenings);
    }
    get additions() {
        return (this.mAdditions);
    }
    get roomElements() {
        return (this.mRoomElements);
    }
    get scaling() {
        return (this.mScaling);
    }
    get scaleGap() {
        return (this.mScaleGap);
    }
    disable2dShadow() {
        for (let tMesh of this.m3dMeshes) {
            // ShadowGenerator.disableMeshShadow(tMesh);
        }
        for (let tMesh of this.m2dMeshes) {
            // ShadowGenerator.disableMeshShadow(tMesh);
        }
    }
    canTranslate() {
        return (this.isSelected && this.mRoomManager.app.model.selection.length > 1);
    }
    canRotate() {
        return (this.isSelected && this.mRoomManager.app.model.selection.length > 1);
    }
    showInteractors(pShow) {
        if (pShow != null) {
            if (pShow)
                this.initEdgeAngleData();
            this.showAngleSector(pShow);
            this.mShowInteractor = pShow;
            this.mInteractors.showInteractors(this.mShowInteractor);
            this.setSelectionShape(pShow, true);
            // check neighbours
            let twallLeft = this.startCxn;
            if (twallLeft.wall != null)
                twallLeft.wall.setSelectionShape(pShow, false);
            let twallRight = this.endCxn;
            if (twallRight.wall != null)
                twallRight.wall.setSelectionShape(pShow, false);
        }
        else {
            this.mInteractors.showInteractors(this.mShowInteractor);
            this.setSelectionShape(false, true);
            // check neighbours
            let twallLeft = this.startCxn;
            if (twallLeft.wall != null)
                twallLeft.wall.setSelectionShape(false, false);
            let twallRight = this.endCxn;
            if (twallRight.wall != null)
                twallRight.wall.setSelectionShape(false, false);
        }
    }
    beginMoving(pMode, pStartPosition) {
        this.mMoveMode = pMode;
        this.misMoving = true;
        WallCrossHair.beginMoving(pStartPosition);
    }
    endMoving(pMode) {
        this.mMoveMode = pMode;
        this.misMoving = false;
        WallCrossHair.endMoving();
    }
    beginOpeningInteraction() {
        if (!this.mOpeningIsInteraction) {
            this.mOpeningIsInteraction = true;
            this.updateGeometry();
        }
    }
    endOpeningInteraction() {
        if (this.mOpeningIsInteraction) {
            this.mOpeningIsInteraction = false;
            this.updateGeometry();
        }
    }
    wallSnapped(psnapped) {
        this.mWallSnapped = psnapped;
        this.setCrossHair(psnapped);
    }
    dispose() {
        super.dispose();
        if (this.mRayPoints != null)
            this.mRayPoints = [];
        if (this.mSelectionShape != null) {
            this.mSelectionShape.dispose();
            this.mScene.removeMesh(this.mSelectionShape);
        }
        if (this.mEdgeAngleData != null) {
            for (let tEAData of this.mEdgeAngleData) {
                tEAData.TextAdvTexture.removeControl(tEAData.TextBlock);
                tEAData.TextBlock.dispose();
                tEAData.TextAdvTexture.dispose();
                tEAData.TextPlane.dispose();
            }
            this.mEdgeAngleData = [];
        }
        this.mRoomManager.app.viewer.scene.onBeforeCameraRenderObservable.removeCallback(this.onBeforeCameraChanged);
        this.mRoomManager.app.viewer.scene.onAfterCameraRenderObservable.removeCallback(this.onAfterCameraChanged);
        this.mInteractors.dispose();
    }
    //TODO: clone ?
    clone(pNewParent) {
        let tClone = new Wall(this.mRoomManager);
        tClone.setStartPoint(this.mStart.clone());
        tClone.setEndPoint(this.mEnd.clone());
        tClone.setThickness(this.mThickness);
        tClone.node.parent = pNewParent != null ? pNewParent : null;
        tClone.copyDataFrom(this);
        tClone.mMaterialB = {};
        tClone.mMaterialB.category = this.mMaterialB.category;
        tClone.mMaterialB.loadMatId = this.mMaterialB.loadMatId;
        tClone.mMaterialB.value = this.mMaterialB.value;
        tClone.mMaterialB.rotation = this.mMaterialB.rotation;
        tClone.mMaterialB.idAddOn = this.mRoomManager.materialSplitStr + tClone.mIdStr + this.mRoomManager.materialSplitStr + "B";
        tClone.mMaterialA = {};
        tClone.mMaterialA.category = this.mMaterialA.category;
        tClone.mMaterialA.loadMatId = this.mMaterialA.loadMatId;
        tClone.mMaterialA.value = this.mMaterialA.value;
        tClone.mMaterialA.rotation = this.mMaterialA.rotation;
        tClone.mMaterialA.idAddOn = this.mRoomManager.materialSplitStr + tClone.mIdStr + this.mRoomManager.materialSplitStr + "A";
        tClone.mRoomManager.checkMaterial(tClone.mMaterialA).then(() => {
            tClone.mRoomManager.checkMaterial(tClone.mMaterialB).then(() => {
                tClone.updateGeometry();
            });
        });
        tClone.eventAdded.addListener(() => this.afterClone(tClone, this));
        return (tClone);
    }
    afterClone(pNewWall, pSourceWall) {
        if (this.mInitialCloning)
            return;
        this.mInitialCloning = true;
        for (let tOpening of pSourceWall.mOpenings) {
            this.mRoomManager.insertWallOpening(tOpening.type, pNewWall).then((pOpening) => {
                if (pOpening !== null) {
                    pOpening.setWidth(tOpening.width);
                    let tWAD = pOpening._WallAttachData;
                    if (tWAD !== null && tOpening._WallAttachData !== null) {
                        tWAD.distanceEnd = tOpening._WallAttachData.distanceEnd;
                        tWAD.distanceStart = tOpening._WallAttachData.distanceStart;
                        pOpening.updateAttachedPosition();
                    }
                    //pOpening.setPosition(tOpening.position);
                }
            });
        }
        this.mInitialCloning = false;
    }
    saveUndoData(pOperation) {
        return (this._saveUndoData());
    }
    loadUndoData(pOperation, pUndoData) {
        this._loadUndoData(pUndoData);
        if (pOperation === UndoOperation.Transform) {
            this.mRoomManager._removeTransformedElement(this);
        }
        this.mRoomManager.findRoom();
    }
    isSelectionHighlightEnabled() {
        let tSel = this.mRoomManager.app.model.selection;
        if (tSel.length !== 1)
            return (true);
        return (false);
    }
    getSelectionHighlightBoundingBox() {
        if (this.mRoomManager.visibilityMode === VisibilityMode.Show2d) {
            let tBounds = this.boundingBox.clone();
            tBounds.max.y = 0.001;
            return (tBounds);
        }
        return (this.boundingBox);
    }
    getPropertyClasses() {
        return (Promise.resolve(this.mRoomManager.PropClasses));
    }
    getProperties() {
        // tslint:disable-next-line:cyclomatic-complexity
        let tPromise = super.getProperties().then((pProperties) => {
            let tProperties = pProperties;
            if (tProperties == null)
                tProperties = new Array();
            //height
            let tHeightProp = new LengthProperty(this, Wall.PROP_KEY_HEIGHT, this.mRoomManager.resources.propertyHeight);
            tHeightProp.class = "base";
            tHeightProp.minValue = 0.01;
            tHeightProp.maxValue = 100;
            tHeightProp.getValue = () => new PropertyValue(this.mHeight);
            tHeightProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null && this.setHeight(tValue))
                    return (Promise.resolve(PropertyChangedResult.Value));
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tHeightProp);
            //thickness
            let tThicknessProp = new LengthProperty(this, Wall.PROP_KEY_THICKNESS, this.mRoomManager.resources.propertyThickness);
            tThicknessProp.class = "base";
            tThicknessProp.minValue = 0.01;
            tThicknessProp.maxValue = 5;
            tThicknessProp.getValue = () => new PropertyValue(this.mThickness);
            tThicknessProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null && this.setThickness(tValue))
                    return (Promise.resolve(PropertyChangedResult.Value));
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tThicknessProp);
            //keep visible ("hidden walls")
            let tYesNoChoices = new Array();
            for (let tYesNo of this.mRoomManager._YesNo)
                tYesNoChoices.push(this.mRoomManager._getYesNoPropValue(tYesNo));
            let tkeepVisibleProp = new BoolProperty(this, Wall.PROP_KEY_KEEPVISIBLE, this.mRoomManager.resources.propertyKeepVisible);
            tkeepVisibleProp.class = "base";
            tkeepVisibleProp.choiceList = true;
            tkeepVisibleProp.getChoices = () => Promise.resolve(tYesNoChoices);
            tkeepVisibleProp.getValue = () => this.mRoomManager._getYesNoPropValue(this.mKeepVisible);
            tkeepVisibleProp.setValue = (pValue) => {
                if (pValue != null) {
                    let tval = BoolProperty.ConvertValueToBool(pValue);
                    this.setLocalVisibility(tval);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tkeepVisibleProp.visible = this.mRoomManager.hideWalls;
            tProperties.push(tkeepVisibleProp);
            // category list
            let tColorChoices = new Array();
            for (let tCol of this.mRoomManager._wallColors)
                tColorChoices.push(this.mRoomManager._getWallColorPropValue(tCol));
            let tMaterialCategory = this.mRoomManager.getMaterial_Categories("wall");
            //length wall side a
            let tLengthRProp = new LengthProperty(this, Wall.PROP_KEY_LENGTH_A, this.mRoomManager.resources.propertyLength);
            tLengthRProp.class = "wallSide_a";
            tLengthRProp.minValue = 0.2;
            tLengthRProp.maxValue = 200;
            tLengthRProp.getValue = () => new PropertyValue(this.getWallLength_A());
            tLengthRProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null) {
                    this.setWallLength(tValue, false, false);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tLengthRProp);
            //material category a
            let tMaterialPropR = new NumberProperty(this, Wall.PROP_KEY_MATERIALCATEGORY_A, this.mRoomManager.resources.propertyMaterialCategory);
            tMaterialPropR.class = "wallSide_a";
            tMaterialPropR.choiceList = true;
            tMaterialPropR.getChoices = () => Promise.resolve(tMaterialCategory);
            tMaterialPropR.getValue = () => this.mRoomManager.getMaterialCategoryValue(tMaterialCategory, this.mMaterialA);
            tMaterialPropR.setValue = (pValue) => {
                if (pValue != null) {
                    this.setMaterialCategory(StringProperty.ConvertValueToString(pValue), undefined, this.mMaterialA);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tMaterialPropR.visible = true;
            tProperties.push(tMaterialPropR);
            //color/material a
            let tpropTitle_A = this.mMaterialA.category === "" ? this.mRoomManager.resources.propertyColor :
                this.mRoomManager.resources.propertyMaterial;
            let tColorRProp;
            if (this.mMaterialA.category === "" || this.mMaterialA.category === "color") {
                tColorRProp = new Color3Property(this, Wall.PROP_KEY_COLOR_A, tpropTitle_A);
            }
            else {
                tColorRProp = new StringProperty(this, Wall.PROP_KEY_COLOR_A, tpropTitle_A);
            }
            tColorRProp.class = "wallSide_a";
            tColorRProp.choiceList = true;
            this.mMatOfCatList_A = this.mRoomManager.getMaterialsOfCategory(this.mMaterialA, "wall");
            tColorRProp.getChoices = () => Promise.resolve(this.mMatOfCatList_A);
            tColorRProp.getValue = () => this.mRoomManager.getMaterialValue(this.mMaterialA, this.mMatOfCatList_A);
            tColorRProp.setValue = (pValue) => {
                let tValue = StringProperty.ConvertValueToString(pValue);
                if (tValue != null) {
                    this.setMaterial(tValue, this.mMaterialA, true);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tColorRProp);
            //texture rotation wall side a
            let tTextureRotation_A_Prop = new NumberProperty(this, Wall.PROP_KEY_TEXROT_A, this.mRoomManager.resources.propertyRotationAngle);
            tTextureRotation_A_Prop.class = "wallSide_a";
            tTextureRotation_A_Prop.minValue = -359;
            tTextureRotation_A_Prop.maxValue = 359;
            tTextureRotation_A_Prop.getValue = () => new PropertyValue(this.mMaterialA.rotation);
            tTextureRotation_A_Prop.setValue = (pValue) => {
                let tValue = NumberProperty.ConvertValueToNumber(pValue);
                if (tValue != null) {
                    this.changeTextureRotation(this.mMaterialA, tValue);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tTextureRotation_A_Prop);
            if (this.mMaterialA.category !== "" && this.mMaterialA.category !== "color")
                tTextureRotation_A_Prop.visible = true;
            else
                tTextureRotation_A_Prop.visible = false;
            //length wall side b
            let tLengthLProp = new LengthProperty(this, Wall.PROP_KEY_LENGTH_B, this.mRoomManager.resources.propertyLength);
            tLengthLProp.class = "wallSide_b";
            tLengthLProp.minValue = 0.2;
            tLengthLProp.maxValue = 200;
            tLengthLProp.getValue = () => new PropertyValue(this.getWallLength_B());
            tLengthLProp.setValue = (pValue) => {
                let tValue = LengthProperty.ConvertValueToNumber(pValue);
                if (tValue != null) {
                    this.setWallLength(tValue, true, false);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tLengthLProp);
            //material category b
            let tMaterialPropL = new NumberProperty(this, Wall.PROP_KEY_MATERIALCATEGORY_B, this.mRoomManager.resources.propertyMaterialCategory);
            tMaterialPropL.class = "wallSide_b";
            tMaterialPropL.choiceList = true;
            tMaterialPropL.getChoices = () => Promise.resolve(tMaterialCategory);
            tMaterialPropL.getValue = () => this.mRoomManager.getMaterialCategoryValue(tMaterialCategory, this.mMaterialB);
            tMaterialPropL.setValue = (pValue) => {
                if (pValue != null) {
                    this.setMaterialCategory(StringProperty.ConvertValueToString(pValue), undefined, this.mMaterialB);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tMaterialPropL.visible = true;
            tProperties.push(tMaterialPropL);
            //color/material b
            let tpropTitle_B = this.mMaterialB.category === "" ? this.mRoomManager.resources.propertyColor :
                this.mRoomManager.resources.propertyMaterial;
            let tColorLProp;
            if (this.mMaterialB.category === "" || this.mMaterialB.category === "color") {
                tColorLProp = new Color3Property(this, Wall.PROP_KEY_COLOR_B, tpropTitle_B);
            }
            else {
                tColorLProp = new StringProperty(this, Wall.PROP_KEY_COLOR_B, tpropTitle_B);
            }
            tColorLProp.class = "wallSide_b";
            tColorLProp.choiceList = true;
            this.mMatOfCatList_B = this.mRoomManager.getMaterialsOfCategory(this.mMaterialB, "wall");
            tColorLProp.getChoices = () => Promise.resolve(this.mMatOfCatList_B);
            tColorLProp.getValue = () => this.mRoomManager.getMaterialValue(this.mMaterialB, this.mMatOfCatList_B);
            tColorLProp.setValue = (pValue) => {
                let tValue = StringProperty.ConvertValueToString(pValue);
                if (tValue != null) {
                    this.setMaterial(tValue, this.mMaterialB, false);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            tProperties.push(tColorLProp);
            //texture rotation wall side a
            let tTextureRotation_B_Prop = new NumberProperty(this, Wall.PROP_KEY_TEXROT_B, this.mRoomManager.resources.propertyRotationAngle);
            tTextureRotation_B_Prop.class = "wallSide_b";
            tTextureRotation_B_Prop.minValue = -359;
            tTextureRotation_B_Prop.maxValue = 359;
            tTextureRotation_B_Prop.getValue = () => new PropertyValue(this.mMaterialB.rotation);
            tTextureRotation_B_Prop.setValue = (pValue) => {
                let tValue = NumberProperty.ConvertValueToNumber(pValue);
                if (tValue != null) {
                    this.changeTextureRotation(this.mMaterialB, tValue);
                    return (Promise.resolve(PropertyChangedResult.Value));
                }
                return (Promise.resolve(PropertyChangedResult.Nothing));
            };
            if (this.mMaterialB.category !== "" && this.mMaterialB.category !== "color")
                tTextureRotation_B_Prop.visible = true;
            else
                tTextureRotation_B_Prop.visible = false;
            tProperties.push(tTextureRotation_B_Prop);
            return (tProperties);
        });
        return (tPromise);
    }
    getWallOpeningsDistanceEnd() {
        let tRes = 0;
        if (this.mOpenings.length === 0)
            return (tRes);
        if (this.mOpenings[0]._WallAttachData !== null)
            tRes = this.mOpenings[0]._WallAttachData.distanceEnd - (this.mOpenings[0].width * 0.5);
        for (let tOpening of this.mOpenings) {
            if (tOpening._WallAttachData === null)
                continue;
            tRes = Math.min(tRes, tOpening._WallAttachData.distanceEnd - (tOpening.width * 0.5));
        }
        return (tRes);
    }
    getWallOpeningsDistanceStart() {
        let tRes = 0;
        if (this.mOpenings.length === 0)
            return (tRes);
        if (this.mOpenings[0]._WallAttachData !== null)
            tRes = this.mOpenings[0]._WallAttachData.distanceStart - (this.mOpenings[0].width * 0.5);
        for (let tOpening of this.mOpenings) {
            if (tOpening._WallAttachData === null)
                continue;
            tRes = Math.min(tRes, tOpening._WallAttachData.distanceStart - (tOpening.width * 0.5));
        }
        return (tRes);
    }
    getWallAdditionssDistanceEnd() {
        let tRes = 0;
        if (this.mAdditions.length === 0)
            return (tRes);
        if (this.mAdditions[0]._WallAttachData !== null)
            tRes = this.mAdditions[0]._WallAttachData.distanceEnd - (this.mAdditions[0].width * 0.5);
        for (let tAddition of this.mAdditions) {
            if (tAddition._WallAttachData === null)
                continue;
            tRes = Math.min(tRes, tAddition._WallAttachData.distanceEnd - (tAddition.width * 0.5));
        }
        return (tRes);
    }
    getWallAdditionsDistanceStart() {
        let tRes = 0;
        if (this.mAdditions.length === 0)
            return (tRes);
        if (this.mAdditions[0]._WallAttachData !== null)
            tRes = this.mAdditions[0]._WallAttachData.distanceStart - (this.mAdditions[0].width * 0.5);
        for (let tAddition of this.mAdditions) {
            if (tAddition._WallAttachData === null)
                continue;
            tRes = Math.min(tRes, tAddition._WallAttachData.distanceStart - (tAddition.width * 0.5));
        }
        return (tRes);
    }
    getWallEndNeighbour(pOtherEnding) {
        if (pOtherEnding === WallEnding.End) {
            return (this.mEndCxn.wall);
        }
        return (this.mStartCxn.wall);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    serialize(pContext) {
        let tIOWall = {};
        tIOWall.classId = WALL_ELEMENT_CLASSID;
        tIOWall.id = this.mId;
        tIOWall.idStr = this.mIdStr;
        tIOWall.start = serializeVector2(this.mStart);
        tIOWall.end = serializeVector2(this.mEnd);
        tIOWall.height = this.mHeight;
        tIOWall.thickness = this.mThickness;
        tIOWall.keepVisible = this.mKeepVisible;
        //material
        let tmatId_B = this.mRoomManager.getMaterialId(this.mMaterialB);
        if (this.mMaterialB.rotation !== 0) {
            tmatId_B += this.mMaterialB.idAddOn;
        }
        let tmatId_A = this.mRoomManager.getMaterialId(this.mMaterialA);
        if (this.mMaterialA.rotation !== 0) {
            tmatId_A += this.mMaterialA.idAddOn;
        }
        tIOWall.WallMaterialSet_A = this.mMaterialA;
        tIOWall.WallMaterialSet_B = this.mMaterialB;
        if (tmatId_B.indexOf(this.mRoomManager.materialSplitStr) !== -1
            && (this.mMaterialB.category !== "" && this.mMaterialB.category !== "color")) {
            let tMatNoB = pContext.addMaterial(tmatId_B);
            tIOWall.WallMaterialL_materialNo = tMatNoB;
        }
        if (tmatId_A.indexOf(this.mRoomManager.materialSplitStr) !== -1
            && (this.mMaterialA.category !== "" && this.mMaterialA.category !== "color")) {
            let tMatNoA = pContext.addMaterial(tmatId_A);
            tIOWall.WallMaterialR_materialNo = tMatNoA;
        }
        if (this.mColorL !== this.mRoomManager._wallColors[0])
            tIOWall.colorL = this.mColorL;
        if (this.mColorR !== this.mRoomManager._wallColors[0])
            tIOWall.colorR = this.mColorR;
        if (this.mStartCxn.wall != null) {
            tIOWall.startCxn = {};
            tIOWall.startCxn.wallId = this.mStartCxn.wall.mId;
            if (this.mStartCxn.wallEnding != null) {
                tIOWall.startCxn.wallEnding = this.mStartCxn.wallEnding === WallEnding.Start ? "s" : "e";
            }
        }
        if (this.mEndCxn.wall != null) {
            tIOWall.endCxn = {};
            tIOWall.endCxn.wallId = this.mEndCxn.wall.mId;
            if (this.mEndCxn.wallEnding != null) {
                tIOWall.endCxn.wallEnding = this.mEndCxn.wallEnding === WallEnding.Start ? "s" : "e";
            }
        }
        tIOWall.openings = new Array();
        for (let tOpening of this.mOpenings) {
            let tIOOpening = tOpening._serializeIOData(pContext);
            if (tIOOpening != null)
                tIOWall.openings.push(tIOOpening);
        }
        tIOWall.additions = new Array();
        for (let tAddition of this.mAdditions) {
            let tIOAddition = tAddition._serializeIOData(pContext);
            if (tIOAddition != null)
                tIOWall.additions.push(tIOAddition);
        }
        return (tIOWall);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getEOXDescription(pDocument, pParentNode) {
        let tAttribsList = new Array();
        let child = pDocument.createElement("dummy"); //dummy node definition for further use
        // wall child
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "structure_type", value: "Wall" });
        let twallNode = Util._xmlAddChildNode(pDocument, pParentNode, "object", "", tAttribsList);
        // define category
        Util._xmlAddChildNode(pDocument, twallNode, "category", "Other", null);
        // position
        tAttribsList = [];
        tAttribsList.push({ qualifiedName: "x", value: this.startPoint.x.toString() });
        tAttribsList.push({ qualifiedName: "y", value: "0" });
        tAttribsList.push({ qualifiedName: "z", value: (-this.startPoint.y).toString() });
        Util._xmlAddChildNode(pDocument, twallNode, "position", "", tAttribsList);
        // rotation
        let tstartPoint = this.startPoint;
        let tendPoint = this.endPoint;
        let tDir = tendPoint.subtract(tstartPoint);
        let tAngle = angleBetweenVectors2(VECTOR2_X, tDir);
        let t3dRotation = Quaternion.RotationAxis(new Vector3(0, 1, 0), -tAngle);
        tAttribsList = [];
        if (tstartPoint.y >= tendPoint.y) {
            tAttribsList.push({ qualifiedName: "x", value: (-t3dRotation.x).toString() });
            tAttribsList.push({ qualifiedName: "y", value: (-t3dRotation.z).toString() });
            tAttribsList.push({ qualifiedName: "z", value: (-t3dRotation.y).toString() });
            tAttribsList.push({ qualifiedName: "w", value: (-t3dRotation.w).toString() });
            Util._xmlAddChildNode(pDocument, twallNode, "rotation", "", tAttribsList);
        }
        else {
            tAttribsList.push({ qualifiedName: "x", value: (-t3dRotation.x).toString() });
            tAttribsList.push({ qualifiedName: "y", value: (t3dRotation.z).toString() });
            tAttribsList.push({ qualifiedName: "z", value: (-t3dRotation.y).toString() });
            tAttribsList.push({ qualifiedName: "w", value: (t3dRotation.w).toString() });
            Util._xmlAddChildNode(pDocument, twallNode, "rotation", "", tAttribsList);
        }
        // length
        Util._xmlAddChildNode(pDocument, twallNode, "length", this.getWallLengthBase().toString(), null);
        // thickness
        Util._xmlAddChildNode(pDocument, twallNode, "thickness", this.thickness.toString(), null);
        // height
        Util._xmlAddChildNode(pDocument, twallNode, "height", this.height.toString(), null);
        // keepVisible
        Util._xmlAddChildNode(pDocument, twallNode, "keepvisible", this.mKeepVisible.toString(), null);
        // color l
        tAttribsList = [];
        if (this.color_l.trim() !== '') {
            let tcolL = Util.hexToRGB(this.color_l);
            tAttribsList.push({ qualifiedName: "r", value: tcolL.r.toString() });
            tAttribsList.push({ qualifiedName: "g", value: tcolL.g.toString() });
            tAttribsList.push({ qualifiedName: "b", value: tcolL.b.toString() });
            Util._xmlAddChildNode(pDocument, twallNode, "color_r", "", tAttribsList);
        }
        // color r
        tAttribsList = [];
        if (this.color_r.trim() !== '') {
            let tcolR = Util.hexToRGB(this.color_r);
            tAttribsList.push({ qualifiedName: "r", value: tcolR.r.toString() });
            tAttribsList.push({ qualifiedName: "g", value: tcolR.g.toString() });
            tAttribsList.push({ qualifiedName: "b", value: tcolR.b.toString() });
            Util._xmlAddChildNode(pDocument, twallNode, "color_l", "", tAttribsList);
        }
        for (let tWO of this.mOpenings) {
            // opening node
            let tOpeningType = "";
            if (tWO.type === "Door") {
                tOpeningType = "SolidDoor";
            }
            if (tWO.type === "DoubleDoor") {
                tOpeningType = "SolidDDoor";
            }
            if (tWO.type === "GlassDoor") {
                tOpeningType = "GlassDoor";
            }
            if (tWO.type === "GlassDoubleDoor") {
                tOpeningType = "GlassDDoor";
            }
            if (tWO.type === "GlassInlayDoor") {
                tOpeningType = "GlassInlayDoor";
            }
            if (tWO.type === "GlassInlayDoubleDoor") {
                tOpeningType = "GlassInlayDDoor";
            }
            if (tWO.type === "Opening") {
                tOpeningType = "Alley";
            }
            if (tWO.type === "Window") {
                tOpeningType = "Window";
            }
            if (tWO.type === "WindowDouble") {
                tOpeningType = "DWindow";
            }
            if (tWO.type === "GlassFront") {
                tOpeningType = "GlassFront";
            }
            //window
            var windowChild = pDocument.createElement("child");
            windowChild.setAttribute("structure_type", tOpeningType);
            twallNode.appendChild(windowChild);
            //<category>Other</category>
            var childobjectCategory = pDocument.createElement("category");
            var childobjectValue = pDocument.createTextNode("Other");
            child = windowChild.appendChild(childobjectCategory);
            child.appendChild(childobjectValue);
            // position
            let cpositionValue = windowChild.appendChild(pDocument.createElement("position"));
            let twallAttachedData = tWO._WallAttachData;
            let tPx = "0";
            let tPy = "0";
            let tPz = "0";
            if (twallAttachedData != null) {
                tPx = (twallAttachedData.distanceStart - (tWO.width * 0.5)).toString();
            }
            // position node attributes
            cpositionValue.setAttribute('x', tPx);
            cpositionValue.setAttribute('y', tPy);
            cpositionValue.setAttribute('z', tPz);
            // rotation
            let crotationValue = windowChild.appendChild(pDocument.createElement("rotation"));
            let twRot = getRotationQuaternion(tWO.node).clone();
            // rotation node attributes
            crotationValue.setAttribute('x', twRot.x.toString());
            crotationValue.setAttribute('y', twRot.y.toString());
            crotationValue.setAttribute('z', twRot.z.toString());
            crotationValue.setAttribute('w', twRot.w.toString());
            // width
            let clengthNode = pDocument.createElement("width");
            let clengthValue = pDocument.createTextNode(tWO.width.toString());
            child = windowChild.appendChild(clengthNode);
            child.appendChild(clengthValue);
            // height
            let cheightNode = pDocument.createElement("height");
            let cheightValue = pDocument.createTextNode(tWO.height.toString());
            child = windowChild.appendChild(cheightNode);
            child.appendChild(cheightValue);
            // parapet
            let cparapetNode = pDocument.createElement("parapet");
            let cparapetValue = pDocument.createTextNode(tWO.floorOffset.toString());
            child = windowChild.appendChild(cparapetNode);
            child.appendChild(cparapetValue);
            // orientation
            let torientation = "inside";
            let talignment = "r";
            if (tWO.mirrorHorizontal) {
                torientation = "outside";
                if (tWO.mirrorVertical)
                    talignment = "r";
                else
                    talignment = "l";
            }
            else if (tWO.mirrorVertical)
                talignment = "l";
            var corientationNode = pDocument.createElement("orientation");
            var corientationValue = pDocument.createTextNode(torientation);
            child = windowChild.appendChild(corientationNode);
            child.appendChild(corientationValue);
            // alignment
            var calignmentNode = pDocument.createElement("alignment");
            var calignmentValue = pDocument.createTextNode(talignment);
            child = windowChild.appendChild(calignmentNode);
            child.appendChild(calignmentValue);
            if (tWO.type === "GlassFront") {
                // column count
                var cColumnCountNode = pDocument.createElement("column_count");
                var cColumnCountValue = pDocument.createTextNode(tWO.OpeningParams.ColumnCount.toString());
                child = windowChild.appendChild(cColumnCountNode);
                child.appendChild(cColumnCountValue);
                // row count; not available till now: set to 1!
                var cRowCountNode = pDocument.createElement("row_count");
                var cRowCountValue = pDocument.createTextNode("1");
                child = windowChild.appendChild(cRowCountNode);
                child.appendChild(cRowCountValue);
            }
        }
        for (let tWA of this.mAdditions) {
            if ((tWA.geometry != null) && (tWA.type !== "PictureFrame")) {
                tWA.geometry.getEOXDescription(pDocument, twallNode, pParentNode, this);
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getEOXDescription_objects(pDocument, pParentNode) {
        for (let tWA of this.mAdditions) {
            if ((tWA.geometry != null) && (tWA.type === "PictureFrame")) {
                tWA.geometry.getEOXDescription_objects(pDocument, pParentNode, this);
            }
        }
    }
    updateGeometry(pTriggerFindConnect = false) {
        if (this.mRoomManager.isCollectingWallUpdates) {
            this.mRoomManager._requestWallUpdate(this);
            return;
        }
        if (!this.isInScene())
            return;
        this.createPickPlane();
        this.updateTransformMatrix();
        this.updateMaterial();
        this.update2dGeometry();
        this.update3dGeometry();
        this.disable2dShadow();
        this.notifyChange(ElementChangedFlags.BoundingBox);
        if (this.mEdgeAngleData != null)
            this.showAngleSector(this.misMoving);
        if (pTriggerFindConnect)
            this.mRoomManager._findWallsConnection_afterLoad();
    }
    _cutEdges() {
        this.cutEdges();
        this.updateGeometry();
    }
    setStartPoint(pPoint) {
        let t_Point = pPoint;
        //if (Util.vectorEquals2(t_Point, this.mStart) || Util.vectorEquals2(t_Point, this.mEnd))
        //    return;
        // minimum wall length: 0.2
        if (this.mIsDrawingNew) {
            this.mEnd = pPoint.add(this.mEnd);
        }
        let tnewWallLength = Vector2.Distance(this.endPoint, t_Point);
        if (tnewWallLength < 0.2)
            return;
        let tminStartPoint = this.getMinStartPoint();
        let tDistEndPoint = Vector2.Distance(tminStartPoint, this.mEnd);
        let tDistNewPosEndPoint = Vector2.Distance(t_Point, this.mEnd);
        if (tDistNewPosEndPoint < tDistEndPoint) {
            let tDir = t_Point.subtract(this.mEnd).normalize();
            let tnewStart = this.mEnd.add(tDir.scale(tDistEndPoint));
            t_Point = tnewStart;
        }
        this.mRoomManager.beginCollectWallUpdates();
        this.mStart.copyFrom(t_Point);
        this.mMovePoint = WallEnding.Start;
        this._setConnection(WallEnding.Start, null, null);
        this.cutEdges();
        this.updateGeometry();
        this.updateConnectedWalls();
        this.updateCrossHair();
        this.mRoomManager.endCollectWallUpdates();
    }
    setEndPoint(pPoint) {
        let t_Point = pPoint;
        //if (Util.vectorEquals2(t_Point, this.mEnd) || Util.vectorEquals2(t_Point, this.mStart))
        //    return;
        // minimum wall length: 0.2
        let tnewWallLength = Vector2.Distance(this.startPoint, t_Point);
        if (tnewWallLength < 0.2)
            return;
        let tmaxEndPoint = this.getMaxEndPoint();
        let tDistStartPoint = Vector2.Distance(tmaxEndPoint, this.mStart);
        let tDistNewPosStartPoint = Vector2.Distance(t_Point, this.mStart);
        if (tDistNewPosStartPoint < tDistStartPoint) {
            let tDir = t_Point.subtract(this.mStart).normalize();
            let tnewEnd = this.mStart.add(tDir.scale(tDistStartPoint));
            t_Point = tnewEnd;
        }
        this.mRoomManager.beginCollectWallUpdates();
        this.mEnd.copyFrom(t_Point);
        this.mMovePoint = WallEnding.End;
        this._setConnection(WallEnding.End, null, null);
        this.cutEdges();
        this.updateGeometry();
        this.updateConnectedWalls();
        this.updateCrossHair();
        this.mRoomManager.endCollectWallUpdates();
    }
    setScaleGap(pValue) {
        this.mScaleGap = pValue;
    }
    setMaterialCategory(pValue, pMatOfCat = "", pMaterial) {
        pMaterial.category = pValue === "color" ? "" : pValue;
        // clear loaded material id
        pMaterial.loadMatId = "";
        let t1stMatOfCat = pMatOfCat;
        if (t1stMatOfCat === "") {
            t1stMatOfCat = this.mRoomManager._getFirstextMaterialOfCategory(pValue);
        }
        pMaterial.value = t1stMatOfCat;
        this.mRoomManager.checkMaterial(pMaterial).then((pResult) => {
            if (pResult === 1 || pResult === 2) {
                this.updateGeometry();
                this.notifyChange(ElementChangedFlags.PropertyValues);
                this.notifyChange(ElementChangedFlags.Properties);
            }
        });
    }
    setMaterial(pValue, pMaterial, pRightWall) {
        let tmatValue = StringProperty.ConvertValueToString(pValue);
        if (tmatValue.trim() === "") {
            pMaterial.value = "";
            // clear loaded material id
            pMaterial.loadMatId = "";
            return;
        }
        // clear loaded material id
        pMaterial.loadMatId = "";
        let tmatGroup = tmatValue.split(this.mRoomManager.materialSplitStr);
        if (tmatGroup !== undefined) {
            if (tmatGroup.length === 1) {
                tmatValue = tmatGroup[0];
                if (pRightWall)
                    this.mColorR = tmatValue;
                else
                    this.mColorL = tmatValue;
            }
            if (tmatGroup.length > 1) {
                tmatValue = tmatGroup[1];
            }
        }
        else {
            tmatValue = "";
        }
        pMaterial.value = tmatValue;
        this.mRoomManager.checkMaterial(pMaterial).then((pResult) => {
            if (pResult === 1 || pResult === 2) {
                this.updateGeometry();
                this.notifyChange(ElementChangedFlags.PropertyValues);
            }
        });
    }
    areWallEdges(pP1, pP2) {
        let tRes = false;
        if (((Util.vectorEquals2(pP1, this.mEdges[0]) || Util.vectorEquals2(pP1, this.mEdges[1])) &&
            (Util.vectorEquals2(pP2, this.mEdges[0]) || Util.vectorEquals2(pP2, this.mEdges[1]))) ||
            ((Util.vectorEquals2(pP1, this.mEdges[2]) || Util.vectorEquals2(pP1, this.mEdges[3])) &&
                (Util.vectorEquals2(pP2, this.mEdges[2]) || Util.vectorEquals2(pP2, this.mEdges[3]))))
            tRes = true;
        else
            tRes = false;
        return (tRes);
    }
    isWallCutEdge(pP) {
        let tRes = false;
        for (let tLine of this.mCutLines) {
            if (Util.vectorEquals3(Util.to3d(pP), tLine[0]) || Util.vectorEquals3(Util.to3d(pP), tLine[1])) {
                tRes = true;
                break;
            }
            tRes = false;
        }
        return (tRes);
    }
    moveWall(pDirection) {
        this.mRoomManager.beginCollectWallUpdates();
        this.mMovePoint = null;
        let tDir = this.mEnd.subtract(this.mStart);
        let ttmpStart = this.mStart.clone();
        let ttmpEnd = this.mEnd.clone();
        this.mStart.addInPlace(pDirection);
        this.mEnd.addInPlace(pDirection);
        let tcanMove = this.updateEndingPosition(true);
        //keep wall length if wall is connected on one side only
        if (this.mStartCxn.wall != null && this.mEndCxn.wall == null) {
            this.mEnd = this.mStart.add(tDir);
        }
        else if (this.mEndCxn.wall != null && this.mStartCxn.wall == null) {
            this.mStart = this.mEnd.subtract(tDir);
        }
        this.cutEdges();
        this.updateGeometry();
        this.updateConnectedWalls();
        // check whether this wall can move reg. openings in
        // connected walls (start, end)
        if (tcanMove != null) {
            if (tcanMove.movedWallEnding === WallEnding.Start) {
                let tDist = Vector2.Distance(ttmpStart, tcanMove.position);
                tDir = ((ttmpStart.clone()).subtract(tcanMove.position.clone())).normalize();
                this.mStart = tcanMove.position;
                this.mEnd = ttmpEnd.subtract(tDir.scale(tDist));
                this.moveWall_Undo();
            }
            else {
                let tDist = Vector2.Distance(ttmpEnd, tcanMove.position);
                tDir = ((tcanMove.position.clone()).subtract(ttmpEnd)).normalize();
                this.mEnd = tcanMove.position;
                this.mStart = ttmpStart.add(tDir.scale(tDist));
                this.moveWall_Undo();
            }
        }
        this.mRoomManager.endCollectWallUpdates();
    }
    moveWall_Undo() {
        this.updateEndingPosition(true);
        this.cutEdges();
        this.updateGeometry();
        this.updateConnectedWalls();
    }
    setWallPosition_start(pPosition, pLength, pDirection) {
        this.mRoomManager.beginCollectWallUpdates();
        this.mMovePoint = null;
        this.mStart = pPosition;
        this.mEnd = this.mStart.add(pDirection.scale(pLength));
        this._setConnection(WallEnding.Start, null, null);
        this.cutEdges();
        this.updateGeometry();
        this.updateConnectedWalls();
        this.mRoomManager.endCollectWallUpdates();
    }
    setWallPosition_end(pPosition, pLength, pDirection) {
        this.mRoomManager.beginCollectWallUpdates();
        this.mMovePoint = null;
        this.mEnd = pPosition;
        this.mStart = this.mEnd.subtract(pDirection.scale(pLength));
        this._setConnection(WallEnding.End, null, null);
        this.cutEdges();
        this.updateGeometry();
        this.updateConnectedWalls();
        this.mRoomManager.endCollectWallUpdates();
    }
    setWallLength(pLength, pLeftWallSide, pScaleInStartDirection = false) {
        let tCmd = new EditWalls(this.mRoomManager);
        try {
            this.mRoomManager.beginCollectWallUpdates();
            let tOldLength;
            if (pLeftWallSide) {
                tOldLength = this.getWallLength_B();
            }
            else {
                tOldLength = this.getWallLength_A();
            }
            let tDeltaLength = pLength - tOldLength;
            let tV1 = null;
            let tV2 = null;
            let tCxn = null;
            let tEnding = null;
            if (pScaleInStartDirection) {
                tV1 = this.endPoint;
                tV2 = this.startPoint;
                tCxn = this.startCxn;
                tEnding = WallEnding.Start;
            }
            else {
                tV1 = this.startPoint;
                tV2 = this.endPoint;
                tCxn = this.endCxn;
                tEnding = WallEnding.End;
            }
            let tDir = tV2.subtract(tV1).normalize();
            let tV = tV1.add(tDir.scale(this.getWallLengthBase() + tDeltaLength));
            if (tCxn.wall == null) {
                if (tEnding === WallEnding.Start)
                    this.setStartPoint(tV);
                else
                    this.setEndPoint(tV);
            }
            else {
                if (this.isWallParallel(tCxn.wall)) {
                    if (tCxn.wallEnding != null) {
                        if (tCxn.wallEnding === WallEnding.Start)
                            tCxn.wall.setStartPoint(tV);
                        else
                            tCxn.wall.setEndPoint(tV);
                    }
                    if (tEnding === WallEnding.Start)
                        this.setStartPoint(tV);
                    else
                        this.setEndPoint(tV);
                }
                else {
                    tV.subtractInPlace(tV2);
                    let tDirections = tCxn.wall._getConnectedWallDirections();
                    tCxn.wall.moveWall(tV);
                    tCxn.wall._handleFlippedWalls(tDirections);
                }
                if (tCxn.wall != null) { //may be null after move
                    tCxn.wall._validateConnections(2);
                }
            }
        }
        finally {
            this.mRoomManager.endCollectWallUpdates();
            this.mRoomManager.app.commands.executeCommand(tCmd);
            this.notifyChange(ElementChangedFlags.PropertyValues);
            this.mRoomManager.findRoom();
        }
    }
    setDrawingNew(pIsDrawingNew) {
        this.mIsDrawingNew = pIsDrawingNew;
        this.updateGeometry();
    }
    setThickness(pThickness) {
        if (eq(pThickness, this.mThickness))
            return (false);
        this.mRoomManager.beginCollectWallUpdates();
        this.mThickness = clamp(pThickness, 0.01, 10);
        this.cutEdges();
        this.updateGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.updateConnectedWalls();
        this.mRoomManager.endCollectWallUpdates(true);
        //update wall openings
        for (let tOpening of this.mOpenings)
            tOpening.updateGeometry();
        //update wall additions
        for (let tAddition of this.mAdditions)
            tAddition.updateGeometry();
        return (true);
    }
    setHeight(pHeight) {
        if (eq(pHeight, this.mHeight))
            return (false);
        this.mHeight = clamp(pHeight, 0.01, 100);
        this.updateGeometry();
        this.updateConnectedWalls();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        return (true);
    }
    setVisibility(pVisible) {
        this.mVisible = pVisible;
    }
    setSidePolygons(pPolygons) {
        this.mSidePolygons = pPolygons;
    }
    // tslint:disable-next-line:cyclomatic-complexity
    shotRay(pShowLines = false) {
        // send ray to check if walls are infront towards camera
        if (!this.mIsInFrustum)
            return;
        let tView = this.mRoomManager.view;
        if (tView === null)
            return;
        // if camera is above ground take lower wall points only (indices: 0, 2, 4, 6, 8, 10)
        // otherwise take upper points
        let tRayHeight = tView.cameraControl.position.y > 0 ? 0 : 1;
        let twallSide = this.getCameraSide();
        let tStart = twallSide === 0 ? tRayHeight : tRayHeight + 6;
        let tEnd = twallSide === 0 ? tRayHeight + 6 : this.mRayPoints.length;
        for (let i = tStart; i < tEnd; i += 2) {
            let tRP = this.mRayPoints[i];
            this.mRay.length = Vector3.Distance(tRP, tView.cameraControl.position);
            let tRayDir = Util.getDirectionToCamera(tRP, tView);
            this.mRay.origin = tRP;
            this.mRay.direction = tRayDir;
            if (pShowLines) {
                let trayHelper = new RayHelper(this.mRay);
                trayHelper.show(this.mScene, Color3.Black());
            }
            let tHits = this.mScene.multiPickWithRay(this.mRay, this.wallFilter);
            if (tHits == null)
                continue;
            if (tHits.length === 0)
                continue;
            if (this.checkRaySelfShot(tHits))
                continue;
            for (let tHit of tHits) {
                if (tHit.pickedMesh == null)
                    continue;
                let twId = tHit.pickedMesh.name.replace("room:wall|", "");
                if (twId === this.id.toString())
                    continue;
                this.mRoomManager.setWallisHidden(twId);
            }
        }
    }
    setHidden(pisHidden = false) {
        this.misHidden = pisHidden;
    }
    getWallAngle() {
        let tVDir = this.mEnd.subtract(this.mStart).normalize();
        return (signedAngleBetweenVectors2(VECTOR2_X, tVDir));
    }
    getAngleBetweenConnectedWall(pMoveWallEnding, pConnectedWall) {
        if (pConnectedWall == null || pConnectedWall.wall == null || pConnectedWall.wallEnding == null)
            return (null);
        let tDir1 = new Vector2(0, 0);
        let tDir2 = new Vector2(0, 0);
        if (pMoveWallEnding === 1) {
            tDir1 = this.mEnd.subtract(this.mStart);
        }
        else {
            tDir1 = this.mStart.subtract(this.mEnd);
        }
        if (pConnectedWall.wallEnding === 0) {
            tDir2 = pConnectedWall.wall.mEnd.subtract(pConnectedWall.wall.mStart);
        }
        else {
            tDir2 = pConnectedWall.wall.mStart.subtract(pConnectedWall.wall.mEnd);
        }
        let tAngle = radToDeg(angleBetweenVectors2(tDir1, tDir2));
        return (tAngle);
    }
    getWallLength_B() {
        return (Vector2.Distance(this.mEdges[3], this.mEdges[2]));
    }
    getWallLength_A() {
        return (Vector2.Distance(this.mEdges[1], this.mEdges[0]));
    }
    getWallLengthBase() {
        return (Vector2.Distance(this.mStart, this.mEnd));
    }
    distanceToPoint(pPoint, pAsLine = false) {
        projectPointOnLine2ToRef(pPoint, this.mStart, this.mEnd, !pAsLine, gTmpVector2_1);
        return (Vector2.Distance(gTmpVector2_1, pPoint));
    }
    pointInside2DWall(pV) {
        return Util.pointInQuadix(pV, this.mEdges[0], this.mEdges[1], this.mEdges[2], this.mEdges[3]) ||
            Util.pointOnQuadix(pV, this.mEdges[0], this.mEdges[1], this.mEdges[2], this.mEdges[3]);
    }
    pointOnWallSide(pV, pSide) {
        if (pSide === WallSide.Left &&
            (Util.vectorEquals2(pV, this.mEdges[2]) || Util.vectorEquals2(pV, this.mEdges[3]))) {
            return (true);
        }
        if (pSide === WallSide.Right &&
            (Util.vectorEquals2(pV, this.mEdges[0]) || Util.vectorEquals2(pV, this.mEdges[1]))) {
            return (true);
        }
        if (pSide === WallSide.Left)
            return isPointOnSegment2(pV, this.mEdges[3], this.mEdges[2]);
        return isPointOnSegment2(pV, this.mEdges[0], this.mEdges[1]);
    }
    isWallParallel(pWall) {
        if (pWall == null)
            return (false);
        return (isParallel2(this.mStart, this.mEnd, pWall.mStart, pWall.mEnd));
    }
    isWallOnLeftSide(pWall) {
        if (pWall == null)
            return (false);
        let tV = this.mStart;
        if (pWall.mStartCxn.wall === this) {
            tV = pWall.mEnd;
        }
        else if (pWall.mEndCxn.wall === this) {
            tV = pWall.mStart;
        }
        return (orientationToLine2(tV, this.mStart, this.mEnd)
            === Orientation.Clockwise);
    }
    isWallOnRightSide(pWall) {
        if (pWall == null)
            return (false);
        let tV = this.mStart;
        if (pWall.mStartCxn.wall === this) {
            tV = pWall.mEnd;
        }
        else if (pWall.mEndCxn.wall === this) {
            tV = pWall.mStart;
        }
        return (orientationToLine2(tV, this.mStart, this.mEnd)
            === Orientation.CounterClockwise);
    }
    createDummySideWalls() {
        let tRE_L = this.mRoomManager.insertWallSide_DummyObjects();
        if (tRE_L !== null) {
            this.mWallSideDummy_L = tRE_L;
            this.mWallSideDummy_L.node.setEnabled(false);
            this.mWallSideDummy_L.setParentWall(this);
            this.mWallSideDummy_L.setWallSidePolygon(this.wallSidePolygons[0]);
            this.mWallSideDummy_L.updateGeometry_GEO();
            let tWM = this.node.getWorldMatrix();
            setLocalMatrix(this.mWallSideDummy_L.node, tWM);
            this.mWallSideDummy_L.updateTransformation();
            this.mWallSideDummy_L.setPosition(this.node.position.clone());
            this.mWallSideDummy_L.node.setParent(this.node);
        }
        let tRE_R = this.mRoomManager.insertWallSide_DummyObjects();
        if (tRE_R !== null) {
            this.mWallSideDummy_R = tRE_R;
            this.mWallSideDummy_R.node.setEnabled(false);
            this.mWallSideDummy_R.setParentWall(this);
            this.mWallSideDummy_R.setWallSidePolygon(this.wallSidePolygons[1]);
            this.mWallSideDummy_R.updateGeometry_GEO();
            let tWM = this.node.getWorldMatrix();
            setLocalMatrix(this.mWallSideDummy_R.node, tWM);
            this.mWallSideDummy_R.updateTransformation();
            this.mWallSideDummy_R.setPosition(this.node.position.clone());
            this.mWallSideDummy_R.node.setParent(this.node);
        }
    }
    checkActiveMesh() {
        this.mIsInFrustum = false;
        let tfrustumPlanes = Frustum.GetPlanes(this.mScene.getTransformMatrix());
        if (this.m3dMeshes.length === 0)
            return;
        for (let tMesh of this.m3dMeshes) {
            if (tMesh.isInFrustum(tfrustumPlanes)) {
                this.mIsInFrustum = true;
                break;
            }
        }
    }
    checkHideWalls() {
        this.mViewTriangle = [];
        if (this.getCameraSide() === 0) {
            this.mViewTriangle.push(this.mEdges[1]);
            this.mViewTriangle.push(this.mEdges[0]);
        }
        else {
            this.mViewTriangle.push(this.mEdges[3]);
            this.mViewTriangle.push(this.mEdges[2]);
        }
        this.mRoomManager.findWallsInViewArea(this.mViewTriangle, this);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    insertWallElement_normalWidth(pWallElement, pEWidth, pEWidth_min, pwallPickPoint, pFrameOffset, pForcePosition = false) {
        let tRes = false;
        let twallPickPoint = pwallPickPoint.clone();
        let ttooSmall = 0;
        for (let tFS of this.mFreeSpace) {
            if (tFS.width < pEWidth) {
                ttooSmall++;
                continue;
            }
            let tDistStart = Vector2.Distance(tFS.start, pwallPickPoint);
            let tDistEnd = Vector2.Distance(tFS.end, pwallPickPoint);
            let tDir = Vector2.Zero();
            if (tDistStart < tDistEnd) {
                tDir = (tFS.end.subtract(tFS.start)).normalize().scale(0.1);
                twallPickPoint = tFS.start.add(tDir);
            }
            else {
                tDir = (tFS.start.subtract(tFS.end)).normalize().scale(0.1);
                twallPickPoint = tFS.end.add(tDir);
            }
            if (pForcePosition)
                twallPickPoint = pwallPickPoint.clone();
            if (isPointOnSegment2(twallPickPoint, tFS.start, tFS.end)) {
                let tFS_distance = tFS.width;
                if (tFS.openingStart)
                    tFS_distance -= pFrameOffset;
                if (tFS.openingEnd)
                    tFS_distance -= pFrameOffset;
                if (tFS_distance >= pEWidth) {
                    twallPickPoint = this.checkPickInsertPoint(twallPickPoint, tFS, pEWidth, pFrameOffset);
                    pWallElement.attachToWall(this, twallPickPoint);
                    pWallElement.setPosition(twallPickPoint);
                    tRes = true;
                    break;
                }
            }
        }
        if (ttooSmall < this.mFreeSpace.length && pForcePosition && !tRes) {
            tRes = this.insertWallElement_normalWidth(pWallElement, pEWidth, pEWidth_min, pwallPickPoint, pFrameOffset, false);
        }
        return (tRes);
    }
    insertWallElement_reducedWidth(pWallElement, pEWidth, pEWidth_min, pwallPickPoint, pFrameOffset, pForcePosition = false) {
        let tRes = false;
        let twallCenter = Vector2.Center(this.mStart, this.mEnd);
        let twallPickPoint = pwallPickPoint.clone();
        //decrease width of wall element
        let ttooSmall = 0;
        for (let tFS of this.mFreeSpace) {
            if (tFS.width < pEWidth_min) {
                ttooSmall++;
                continue;
            }
            let tFS_distance = tFS.width;
            tFS_distance -= pFrameOffset * 4;
            pWallElement.setWidth(tFS_distance, true);
            let tDistStart = Vector2.Distance(tFS.start, twallCenter);
            let tDistEnd = Vector2.Distance(tFS.end, twallCenter);
            let tDir = Vector2.Zero();
            if (tDistStart < tDistEnd) {
                tDir = (tFS.end.subtract(tFS.start)).normalize().scale(0.1);
                twallPickPoint = tFS.start.add(tDir);
            }
            else {
                tDir = (tFS.start.subtract(tFS.end)).normalize().scale(0.1);
                twallPickPoint = tFS.end.add(tDir);
            }
            if (pForcePosition)
                twallPickPoint = pwallPickPoint.clone();
            if (isPointOnSegment2(twallPickPoint, tFS.start, tFS.end)) {
                twallPickPoint = Vector2.Center(tFS.start, tFS.end);
                pWallElement.attachToWall(this, twallPickPoint);
                tRes = true;
                break;
            }
        }
        if (ttooSmall < this.mFreeSpace.length && pForcePosition && !tRes) {
            tRes = this.insertWallElement_reducedWidth(pWallElement, pEWidth, pEWidth_min, pwallPickPoint, pFrameOffset, false);
        }
        return (tRes);
    }
    insertWallElementOnPosition(pWallElement, pDestPos, pClone) {
        let tRes = false;
        let twallCenter = Vector2.Center(this.mStart, this.mEnd);
        let tForcePosition = false;
        let tOpening = (pWallElement instanceof WallOpening) ? true : false;
        if (pDestPos == null) {
            pDestPos = Util.to3d(twallCenter.clone());
        }
        else {
            tForcePosition = true;
        }
        let tfO = 0;
        if (pWallElement instanceof WallOpening) {
            tfO = Wall.WALLOPENING_FRAMEOFFSET;
        }
        let tEWidth = pWallElement.width + tfO * 2;
        let tEWidth_min = tEWidth;
        let twallPickPoint = new Vector2(0, 0);
        twallPickPoint = this.getWallPointOfPickPoint(pDestPos);
        if (pWallElement instanceof WallOpening) {
            tEWidth_min = pWallElement.OpeningParams.minWidth;
        }
        // place in wall center
        if (tOpening) {
            if (this.mOpenings.length === 0) {
                pWallElement.attachToWall(this, twallPickPoint);
                return (true);
            }
        }
        else if (this.mAdditions.length === 0) {
            pWallElement.attachToWall(this, twallPickPoint);
            return (true);
        }
        tRes = this.insertWallElement_normalWidth(pWallElement, tEWidth, tEWidth_min, twallPickPoint, tfO, tForcePosition);
        if (tRes)
            return (true);
        if (pClone)
            return (tRes);
        tRes = this.insertWallElement_reducedWidth(pWallElement, tEWidth, tEWidth_min, twallPickPoint, tfO, tForcePosition);
        return (tRes);
    }
    getDestPositionBasedOnSelection(pDestPos) {
        let tRes = Util.to3d(this.wallCenter);
        if (pDestPos != null)
            tRes = pDestPos;
        // tslint:disable-next-line:no-collapsible-if
        if (pDestPos == null) {
            if (this.mRoomManager.app.model.selection.length === 1) {
                if (this.mRoomManager.app.model.selection[0] === this) {
                    tRes = Util.to3d(this.wallCenter);
                }
                if (this.mRoomManager.app.model.selection[0] instanceof WallOpening) {
                    let tWO = this.mRoomManager.app.model.selection[0].position;
                    tRes = Util.to3d(tWO);
                }
                if (this.mRoomManager.app.model.selection[0] instanceof WallAddition) {
                    let tWO = this.mRoomManager.app.model.selection[0].position;
                    tRes = Util.to3d(tWO);
                }
            }
        }
        return (tRes);
    }
    getDestPositionBasedOnSelectionV2(pDestPos) {
        let tRes = this.wallCenter;
        if (pDestPos != null)
            tRes = pDestPos;
        // tslint:disable-next-line:no-collapsible-if
        if (pDestPos == null) {
            if (this.mRoomManager.app.model.selection.length === 1) {
                if (this.mRoomManager.app.model.selection[0] === this) {
                    tRes = this.wallCenter;
                }
                if (this.mRoomManager.app.model.selection[0] instanceof WallOpening) {
                    let tWO = this.mRoomManager.app.model.selection[0].position;
                    tRes = tWO;
                }
                if (this.mRoomManager.app.model.selection[0] instanceof WallAddition) {
                    let tWO = this.mRoomManager.app.model.selection[0].position;
                    tRes = tWO;
                }
            }
        }
        return (tRes);
    }
    checkInsertWallElement(pWallElement, pOpening = true, pDestPos = null, pComparePosition = null, pClone = false) {
        let tRes = false;
        let tDestPos = pDestPos === null || pDestPos === void 0 ? void 0 : pDestPos.clone();
        tDestPos = this.getDestPositionBasedOnSelection(tDestPos);
        let tComparePosition = pComparePosition === null || pComparePosition === void 0 ? void 0 : pComparePosition.clone();
        tComparePosition = this.getDestPositionBasedOnSelectionV2(tComparePosition);
        this.checkFreeWallSpace(pOpening, tComparePosition);
        let tinsRes = this.insertWallElementOnPosition(pWallElement, tDestPos, pClone);
        if (tinsRes)
            return (tinsRes);
        return (tRes);
    }
    removeDummySideWalls() {
        if (this.mWallSideDummy_L != null) {
            this.mWallSideDummy_L.node.parent = null;
            this.mRoomManager.removeWallSideDummy(this.mWallSideDummy_L);
        }
        if (this.mWallSideDummy_R != null) {
            this.mWallSideDummy_R.node.parent = null;
            this.mRoomManager.removeWallSideDummy(this.mWallSideDummy_R);
        }
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    get _edges() {
        return (this.mEdges);
    }
    /** @internal */
    get _localEdges() {
        return (this.mLocalEdges);
    }
    /** @internal */
    get cutLines() {
        return (this.mCutLines);
    }
    /** @internal */
    get _materialA() {
        let tmatId = this.mRoomManager.getMaterialId(this.mMaterialA);
        let tMat = null;
        if (this.mMaterialA.rotation === 0) {
            tMat = this.mRoomManager.MatManager.getMaterial(tmatId);
        }
        else {
            tmatId = tmatId + this.mMaterialA.idAddOn;
            tMat = this.mRoomManager.MatManager.getMaterial(tmatId);
        }
        if (tMat != null) {
            return (tMat);
        }
        return (this.mRoomManager.wallDefaultMaterial);
    }
    /** @internal */
    get _materialB() {
        let tmatId = this.mRoomManager.getMaterialId(this.mMaterialB);
        let tMat = null;
        if (this.mMaterialB.rotation === 0) {
            tMat = this.mRoomManager.MatManager.getMaterial(tmatId);
        }
        else {
            tmatId = tmatId + this.mMaterialB.idAddOn;
            tMat = this.mRoomManager.MatManager.getMaterial(tmatId);
        }
        if (tMat != null) {
            return (tMat);
        }
        return (this.mRoomManager.wallDefaultMaterial);
    }
    /** @internal */
    _saveUndoData() {
        let tData = {};
        tData.start = this.mStart.clone();
        tData.startCxnWall = this.mStartCxn.wall;
        tData.startCxnWallEnding = this.mStartCxn.wallEnding;
        tData.end = this.mEnd.clone();
        tData.endCxnWall = this.mEndCxn.wall;
        tData.endCxnWallEnding = this.mEndCxn.wallEnding;
        tData.height = this.mHeight;
        tData.thickness = this.mThickness;
        tData.sideWalls = new Map();
        for (let tWall of this.mRoomManager.walls) {
            if (tWall === this)
                continue;
            if (tWall.mStartCxn.wallEnding == null && tWall.mStartCxn.wall === this) {
                tData.sideWalls.set(tWall, WallEnding.Start);
            }
            else if (tWall.mEndCxn.wallEnding == null && tWall.mEndCxn.wall === this) {
                tData.sideWalls.set(tWall, WallEnding.End);
            }
        }
        tData.openingPositions = new Map();
        for (let tOpening of this.mOpenings)
            tData.openingPositions.set(tOpening, tOpening.position.clone());
        tData.additionPositions = new Map();
        for (let tAddition of this.mAdditions)
            tData.additionPositions.set(tAddition, tAddition.position.clone());
        return (tData);
    }
    /** @internal */
    _loadUndoData(pData) {
        if (pData == null)
            return;
        this.mRoomManager.beginCollectWallUpdates();
        let tWallDirections = this._getConnectedWallDirections();
        this.mStart = pData.start.clone();
        this.mEnd = pData.end.clone();
        this.setThickness(pData.thickness);
        this.setHeight(pData.height);
        this.updateEdges();
        //restore end to end connections
        this._setConnection(WallEnding.Start, pData.startCxnWall, pData.startCxnWallEnding);
        this._setConnection(WallEnding.End, pData.endCxnWall, pData.endCxnWallEnding);
        //restore side connections
        pData.sideWalls.forEach((pEnding, pWall) => {
            pWall._setConnection(pEnding, this, null);
        });
        this.updateEndingPosition(true);
        this.cutEdges();
        this.updateGeometry();
        this.updateConnectedWalls();
        this._handleFlippedWalls(tWallDirections);
        pData.openingPositions.forEach((pPos, pOpening) => {
            if (pOpening.wall === this) {
                pOpening.setPosition(pPos, false);
            }
            else {
                pOpening.attachToWall(this, pPos);
            }
        });
        pData.additionPositions.forEach((pPos, pAddition) => {
            if (pAddition.wall === this) {
                pAddition.setPosition(pPos, false);
            }
            else {
                pAddition.attachToWall(this, pPos);
            }
        });
        this.mRoomManager.endCollectWallUpdates(true);
    }
    /** @internal */
    _addOpening(pOpening) {
        if (pOpening == null)
            return;
        if (!contains(this.mOpenings, pOpening)) {
            this.mOpenings.push(pOpening);
            this.updateGeometry();
        }
    }
    /** @internal */
    _removeOpening(pOpening) {
        if (pOpening == null)
            return;
        if (removeElement(this.mOpenings, pOpening))
            this.updateGeometry();
        this.mRoomManager.contentChanged();
    }
    /** @internal */
    _addAddition(pAddition) {
        if (pAddition == null)
            return;
        if (!contains(this.mAdditions, pAddition)) {
            this.mAdditions.push(pAddition);
            this.updateGeometry();
        }
    }
    /** @internal */
    _removeAddition(pAddition) {
        if (pAddition == null)
            return;
        if (removeElement(this.mAdditions, pAddition))
            this.updateGeometry();
        this.mRoomManager.contentChanged();
    }
    /** @internal */
    _addRoomElement(pElement) {
        if (pElement == null)
            return;
        if (!contains(this.mRoomElements, pElement)) {
            this.mRoomElements.push(pElement);
            this.updateGeometry();
        }
    }
    /** @internal */
    _removeRoomElement(pOpening) {
        if (pOpening == null)
            return;
        if (removeElement(this.mRoomElements, pOpening))
            this.updateGeometry();
    }
    /** @internal */
    // tslint:disable-next-line:cyclomatic-complexity
    _setConnection(pEnding, pOtherWall, pOtherEnding, pForce = false) {
        let tCxt = pEnding === WallEnding.Start ? this.mStartCxn : this.mEndCxn;
        let tCxt2 = pEnding === WallEnding.End ? this.mStartCxn : this.mEndCxn;
        if (!pForce &&
            (pOtherWall === tCxt.wall || (pOtherWall != null && pOtherWall === tCxt2.wall)))
            return;
        //remove old connection
        if (tCxt.wall !== null) {
            if (tCxt.wall.mStartCxn.wall === this) {
                tCxt.wall.mStartCxn.wall = null;
                if (tCxt.wall !== null)
                    tCxt.wall.mStartCxn.wallEnding = null;
            }
            if (tCxt.wall !== null && (tCxt.wall.mEndCxn.wall === this)) {
                tCxt.wall.mEndCxn.wall = null;
                if (tCxt.wall !== null)
                    tCxt.wall.mEndCxn.wallEnding = null;
            }
            if (tCxt.wall !== null) {
                let tOldWall = tCxt.wall;
                tCxt.wall = null;
                tOldWall.cutEdges();
                tOldWall.updateGeometry();
            }
        }
        tCxt.wall = pOtherWall;
        tCxt.wallEnding = pOtherEnding;
        //setup new end to end connection
        if (tCxt.wall != null && pOtherEnding != null) {
            if (pOtherEnding === WallEnding.Start) {
                tCxt.wall.mStartCxn.wall = this;
                tCxt.wall.mStartCxn.wallEnding = pEnding;
            }
            else {
                tCxt.wall.mEndCxn.wall = this;
                tCxt.wall.mEndCxn.wallEnding = pEnding;
            }
        }
        this.cutEdges();
        this.updateGeometry();
        if (tCxt.wall != null) {
            tCxt.wall.cutEdges();
            tCxt.wall.updateGeometry();
        }
        this.setDrawingNew(false);
    }
    /** @internal */
    // tslint:disable-next-line:cyclomatic-complexity
    _validateConnections(pMaxIterations, pCurrentIteration = 0) {
        let tOldS = this.mStartCxn.wall;
        let tOldE = this.mEndCxn.wall;
        if (this.mStartCxn.wall != null) {
            let tW = this.mStartCxn.wall;
            if (!(tW.isWallOnLeftSide(this)) &&
                !(tW.isWallOnRightSide(this)) &&
                this.mStartCxn.wallEnding == null) {
                this._setConnection(WallEnding.Start, null, null);
            }
            else {
                let tV = Vector2.Center(this.mEdges[0], this.mEdges[3]);
                if (!tW.pointInside2DWall(tV) && this.mStartCxn.wallEnding == null) {
                    this.mStart = tV;
                    this._setConnection(WallEnding.Start, null, null);
                }
            }
        }
        if (this.mEndCxn.wall != null) {
            let tW = this.mEndCxn.wall;
            if (!(tW.isWallOnLeftSide(this)) &&
                !(tW.isWallOnRightSide(this)) &&
                this.mEndCxn.wallEnding == null) {
                this._setConnection(WallEnding.End, null, null);
            }
            else {
                let tV = Vector2.Center(this.mEdges[1], this.mEdges[2]);
                if (!tW.pointInside2DWall(tV) && this.mEndCxn.wallEnding == null) {
                    this.mEnd = tV;
                    this._setConnection(WallEnding.End, null, null);
                }
            }
        }
        if (pCurrentIteration < pMaxIterations)
            this.validateConnectedWalls(pMaxIterations, pCurrentIteration);
        return (tOldS !== this.mStartCxn.wall || tOldE !== this.mEndCxn.wall);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    _checkWallIntersection(pEnding, pForce = false) {
        let tPoint1;
        if (pEnding === WallEnding.Start) {
            tPoint1 = this.mStart;
        }
        else {
            tPoint1 = this.mEnd;
        }
        let tOtherWall = this.mRoomManager.getNearestWall(tPoint1, this);
        if ((!this.mRoomManager.app.settings.snapping.boundingBoxEnabled ||
            !this.mRoomManager.app.settings.snapping.gridEnabled) &&
            (tOtherWall != null && !isPointOnSegment2(tPoint1, tOtherWall.startPoint, tOtherWall.endPoint))) {
            let tpointInEdges = Util.pointInPolygon(tPoint1, tOtherWall._edges);
            if (tpointInEdges) {
                // find intersection point
                let tintersectPoint = Util.getIntersectionPointV2(this.mStart, this.mEnd, tOtherWall.startPoint, tOtherWall.endPoint, false);
                let tdistS = Vector2.Distance(tPoint1, tOtherWall.startPoint);
                let tdistE = Vector2.Distance(tPoint1, tOtherWall.endPoint);
                if (tdistS < 0.1 || tdistE < 0.1) {
                    if (tdistS < 0.1) {
                        if (pEnding === WallEnding.Start) {
                            this.mStart = tOtherWall.startPoint.clone();
                        }
                        else {
                            this.mEnd = tOtherWall.startPoint.clone();
                        }
                    }
                    else if (pEnding === WallEnding.Start) {
                        this.mStart = tOtherWall.endPoint.clone();
                    }
                    else {
                        this.mEnd = tOtherWall.endPoint.clone();
                    }
                }
                else if (tintersectPoint != null && isPointOnSegment2(tintersectPoint, tOtherWall.startPoint, tOtherWall.endPoint)) {
                    if (pEnding === WallEnding.Start) {
                        this.mStart = tintersectPoint;
                    }
                    else {
                        this.mEnd = tintersectPoint;
                    }
                }
            }
        }
    }
    /** @internal */
    _findNewConnection(pEnding, pForce = false) {
        this._checkWallIntersection(pEnding, pForce);
        let tPoint1;
        let tPoint2;
        if (pEnding === WallEnding.Start) {
            tPoint1 = this.mStart;
            tPoint2 = this.mEnd;
        }
        else {
            tPoint1 = this.mEnd;
            tPoint2 = this.mStart;
        }
        let tOtherWall = this.mRoomManager.getNearestWall(tPoint1, this);
        if (tOtherWall != null && isPointOnSegment2(tPoint1, tOtherWall.startPoint, tOtherWall.endPoint)) {
            let tOtherEnding = null;
            if (Util.vectorEquals2(tPoint1, tOtherWall.startPoint)) {
                if (tOtherWall.startCxn.wall == null)
                    tOtherEnding = WallEnding.Start;
                else {
                    //check if current wall is best possible
                    let tDist1 = tOtherWall.distanceToPoint(tPoint2, true);
                    let tDist2 = tOtherWall.startCxn.wall.distanceToPoint(tPoint2, true);
                    if (tDist2 > tDist1)
                        tOtherWall = tOtherWall.startCxn.wall;
                }
            }
            else if (Util.vectorEquals2(tPoint1, tOtherWall.endPoint)) {
                if (tOtherWall.endCxn.wall == null)
                    tOtherEnding = WallEnding.End;
                else {
                    //check if current wall is best possible
                    let tDist1 = tOtherWall.distanceToPoint(tPoint2, true);
                    let tDist2 = tOtherWall.endCxn.wall.distanceToPoint(tPoint2, true);
                    if (tDist2 > tDist1)
                        tOtherWall = tOtherWall.endCxn.wall;
                }
            }
            this._setConnection(pEnding, tOtherWall, tOtherEnding, pForce);
            return (true);
        }
        return (false);
    }
    /** @internal */
    _findNewConnection_static(pEnding, pForce = false) {
        let tPoint1;
        let tPoint2;
        if (pEnding === WallEnding.Start) {
            tPoint1 = this.mStart;
            tPoint2 = this.mEnd;
        }
        else {
            tPoint1 = this.mEnd;
            tPoint2 = this.mStart;
        }
        let tOtherWall = this.mRoomManager.getNearestWall(tPoint1, this);
        if (tOtherWall != null && isPointOnSegment2(tPoint1, tOtherWall.startPoint, tOtherWall.endPoint)) {
            let tOtherEnding = null;
            if (Util.vectorEquals2(tPoint1, tOtherWall.startPoint)) {
                tOtherEnding = WallEnding.Start;
            }
            else if (Util.vectorEquals2(tPoint1, tOtherWall.endPoint)) {
                tOtherEnding = WallEnding.End;
            }
            this._setConnection(pEnding, tOtherWall, tOtherEnding, pForce);
            return (true);
        }
        return (false);
    }
    /** @internal */
    _interactionFinished() {
        if (this.m3dNeedsUpdate) {
            this.update3dGeometry();
            this.update2dVisibility();
        }
    }
    /** @internal */
    _getConnectedWallDirections() {
        let tMap = new Map();
        for (let tWall of this.mRoomManager.walls) {
            if (tWall === this || tWall === tWall.mStartCxn.wall || tWall === tWall.mEndCxn.wall)
                continue;
            if (tWall.mStartCxn.wall === this || tWall.mEndCxn.wall === this) {
                let tDir = tWall.mEnd.subtract(tWall.mStart).normalize();
                tMap.set(tWall, tDir);
            }
        }
        return (tMap);
    }
    /** @internal */
    _handleFlippedWalls(pDirectionMap) {
        if (pDirectionMap == null)
            return;
        pDirectionMap.forEach((pDir, pWall) => {
            let tDir = pWall.mEnd.subtract(pWall.mStart).normalize();
            if (!Util.vectorEquals2(pDir, tDir)) {
                let tWall = null;
                if (pWall.mStartCxn.wall !== this)
                    tWall = pWall.mStartCxn.wall;
                else if (pWall.mEndCxn.wall !== this)
                    tWall = pWall.mEndCxn.wall;
                if (tWall != null) {
                    tWall.cutEdges();
                    tWall.updateGeometry();
                }
            }
        });
    }
    /** @internal */
    getAllSideWalls(pWallsLeft, pWallsRight, pWithEndToEnd, pSort) {
        for (let tWall of this.mRoomManager.walls) {
            // tslint:disable-next-line:no-collapsible-if
            if (tWall !== this &&
                ((tWall !== this.mStartCxn.wall && tWall !== this.mEndCxn.wall) || pWithEndToEnd)) {
                if (tWall.mStartCxn.wall === this || tWall.mEndCxn.wall === this) {
                    if (this.isWallOnRightSide(tWall))
                        pWallsRight.push(tWall);
                    else if (this.isWallOnLeftSide(tWall))
                        pWallsLeft.push(tWall);
                }
            }
        }
        Wall.gCurrentWall = this;
        pWallsLeft.sort(Wall.cmpWallDistance);
        pWallsRight.sort(Wall.cmpWallDistance);
    }
    /** @internal */
    // tslint:disable-next-line:cyclomatic-complexity
    _getNeighbourDistance(pEnding, pSide) {
        let tResult = {
            distance: 0,
            refPos1: null,
            refPos2: null,
            negateDir: false
        };
        let tW = null;
        // ceck conditions
        if (pEnding === WallEnding.Start) {
            if (this.mStartCxn.wall == null)
                return (null);
            tW = this.mStartCxn.wall;
            //check if it is a special end to end case
            if (this.mStartCxn.wallEnding != null && tW.mEndCxn.wall === this &&
                (pSide === WallSide.Left && tW.isWallOnLeftSide(this) ||
                    pSide === WallSide.Right && tW.isWallOnRightSide(this))) {
                return this.getNeighbourDistanceEE(pEnding, pSide);
            }
            if (this.mStartCxn.wallEnding != null && tW.mStartCxn.wall === this &&
                (pSide === WallSide.Right && tW.isWallOnLeftSide(this) ||
                    pSide === WallSide.Left && tW.isWallOnRightSide(this))) {
                return this.getNeighbourDistanceEE(pEnding, pSide);
            }
        }
        else {
            if (this.mEndCxn.wall == null)
                return (null);
            tW = this.mEndCxn.wall;
            //check if it is a special end to end case
            if (this.mEndCxn.wallEnding != null && tW.mEndCxn.wall === this &&
                (pSide === WallSide.Left && tW.isWallOnLeftSide(this) ||
                    pSide === WallSide.Right && tW.isWallOnRightSide(this))) {
                return this.getNeighbourDistanceEE(pEnding, pSide);
            }
            if (this.mEndCxn.wallEnding != null && tW.mStartCxn.wall === this &&
                (pSide === WallSide.Right && tW.isWallOnLeftSide(this) ||
                    pSide === WallSide.Left && tW.isWallOnRightSide(this))) {
                return this.getNeighbourDistanceEE(pEnding, pSide);
            }
        }
        if (this.isWallParallel(tW)) {
            return (null);
        }
        //find neighbour walls
        let tWL = null;
        let tWR = null;
        let tV1 = Vector2.Zero();
        let tV2 = Vector2.Zero();
        let tNeg = 1;
        let tNeighbours = this.getNeighbours(pEnding);
        if (tNeighbours != null) {
            if (tW.isWallOnLeftSide(this)) {
                tWL = tNeighbours.right;
                tWR = tNeighbours.left;
            }
            else {
                tWL = tNeighbours.left;
                tWR = tNeighbours.right;
            }
        }
        //get relevant points
        if (pSide === WallSide.Left) {
            if (tWL != null) {
                if (tWL.mStartCxn.wall === tW)
                    tV1 = tWL.mEdges[3];
                else
                    tV1 = tWL.mEdges[1];
            }
            else if (tW.isWallOnLeftSide(this))
                tV1 = tW.mEdges[2];
            else
                tV1 = tW.mEdges[0];
            if (this.mStartCxn.wall === tW)
                tV2 = this.mEdges[0];
            else
                tV2 = this.mEdges[2];
            //to determine if it is a negative dist
            if (tW.isWallOnLeftSide(this))
                tNeg = -1;
        }
        else {
            if (tWR != null) {
                if (tWR.mStartCxn.wall === tW)
                    tV1 = tWR.mEdges[0];
                else
                    tV1 = tWR.mEdges[2];
            }
            else if (tW.isWallOnLeftSide(this))
                tV1 = tW.mEdges[3];
            else
                tV1 = tW.mEdges[1];
            if (this.mStartCxn.wall === tW)
                tV2 = this.mEdges[3];
            else
                tV2 = this.mEdges[1];
            //to determine if it is a negative dist
            if (tW.isWallOnRightSide(this))
                tNeg = -1;
        }
        tResult.refPos1 = tV1;
        tResult.refPos2 = tV2;
        //negate distance if necessary
        if (!Util.vectorEquals2(tV1.subtract(tV2).normalize(), tW.mStart.subtract(tW.mEnd).normalize()))
            tResult.distance = (Vector2.Distance(tV1, tV2) * -tNeg);
        else
            tResult.distance = (Vector2.Distance(tV1, tV2) * tNeg);
        if (eq(tResult.distance, 0.0))
            tResult.distance = Math.abs(tResult.distance);
        return (tResult);
    }
    /** @internal */
    _finishLoading(pIOWall) {
        if (pIOWall == null)
            return;
        if (pIOWall.startCxn != null) {
            let tOtherEnding = null;
            if (pIOWall.startCxn.wallEnding != null)
                tOtherEnding = pIOWall.startCxn.wallEnding === "s" ? WallEnding.Start : WallEnding.End;
            let tOtherWall = this.mRoomManager._getLoadedWallById(pIOWall.startCxn.wallId);
            this._setConnection(WallEnding.Start, tOtherWall, tOtherEnding);
        }
        if (pIOWall.endCxn != null) {
            let tOtherEnding = null;
            if (pIOWall.endCxn.wallEnding != null)
                tOtherEnding = pIOWall.endCxn.wallEnding === "s" ? WallEnding.Start : WallEnding.End;
            let tOtherWall = this.mRoomManager._getLoadedWallById(pIOWall.endCxn.wallId);
            this._setConnection(WallEnding.End, tOtherWall, tOtherEnding);
        }
    }
    /** @internal */
    _updateVisibility(pUpdateBoundingBox = true) {
        this.update2dVisibility();
        this.update3dVisibility(true);
        //update selection bounds
        if (pUpdateBoundingBox)
            this.notifyChange(ElementChangedFlags.BoundingBox);
    }
    /** @internal */
    // tslint:disable-next-line:cyclomatic-complexity
    _finishTransformation() {
        if (this.mPendingTransformMatrix == null)
            return;
        this.mRoomManager._removeFloor();
        //disconnect walls which where not transformed
        if (this.mStartCxn.wall != null && !this.mRoomManager._wasElementTransformed(this.mStartCxn.wall))
            this._setConnection(WallEnding.Start, null, null);
        if (this.mEndCxn.wall != null && !this.mRoomManager._wasElementTransformed(this.mEndCxn.wall))
            this._setConnection(WallEnding.End, null, null);
        for (let tWall of this.mRoomManager.walls) {
            if (tWall === this)
                continue;
            if (!this.mRoomManager._wasElementTransformed(tWall)) {
                if (tWall.mStartCxn.wall === this) {
                    tWall._setConnection(WallEnding.Start, null, null);
                }
                if (tWall.mEndCxn.wall === this) {
                    tWall._setConnection(WallEnding.End, null, null);
                }
            }
        }
        //transfom start and end
        this.mStart = Util.to2d(Vector3.TransformCoordinates(VECTOR3_ZERO, this.mPendingTransformMatrix));
        this.mEnd = Util.to2d(Vector3.TransformCoordinates(new Vector3(this.mTransformWallLength, 0, 0), this.mPendingTransformMatrix));
        this.mPendingTransformMatrix = null;
        this.updateEdges();
        this.updateEndingPosition(true);
        this.cutEdges();
        this.updateGeometry();
        this.updateConnectedWalls();
    }
    /** @internal */
    static _registerClass(pRoomManager) {
        pRoomManager.app.model.registerElementLoader(WALL_ELEMENT_CLASSID, (pApp, pContext, pIOElement) => {
            return (Wall.deserialize(pRoomManager, pContext, pIOElement));
        });
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    handleImmediateChanges() {
        super.handleImmediateChanges();
        if (this.wasFlagChanged(ElementChangedFlags.Added))
            this.mRoomManager._addWall(this);
        if (this.wasFlagChanged(ElementChangedFlags.Removed)) {
            if (this.mWallSideDummy_R != null) {
                this.mRoomManager.removeWallSideDummy(this.mWallSideDummy_R);
            }
            if (this.mWallSideDummy_L != null) {
                this.mRoomManager.removeWallSideDummy(this.mWallSideDummy_L);
            }
            if (this.mRoomManager._removeWall(this)) {
                this.mRoomManager.beginCollectWallUpdates();
                this._setConnection(WallEnding.Start, null, null);
                this._setConnection(WallEnding.End, null, null);
                //disconnet sidewalls
                for (let tWall of this.mRoomManager.walls) {
                    if (tWall === this)
                        continue;
                    if (tWall.mStartCxn.wall === this)
                        tWall._setConnection(WallEnding.Start, null, null);
                    else if (tWall.mEndCxn.wall === this)
                        tWall._setConnection(WallEnding.End, null, null);
                }
                this.mRoomManager.endCollectWallUpdates();
                this.mRoomManager.findRoom();
            }
        }
    }
    handleDelayedChanges() {
        super.handleDelayedChanges();
        if (this.wasFlagChanged(ElementChangedFlags.Transformation) && this.mHandleTansformationChange) {
            if (this.mRoomManager._transformationStarted()) {
                this.mPendingTransformMatrix = this.transform.clone();
                this.mTransformWallLength = this.getWallLengthBase();
                this.mRoomManager._addTransformedElement(this);
            }
            else
                this.updateTransformMatrix(); // reset transform
        }
    }
    setSelectionShape(pVisible, pMainWall) {
        this.mRoomManager.wall2dMaterialSelected.albedoColor = Color3.FromHexString(this.mRoomManager.app.theme.mainColorBright).toLinearSpace();
        this.mSelectionShapeActive = pVisible;
        if (this.mSelectionShape !== null) {
            if (this.mRoomManager.app.model.selection.length > 1) {
                this.mSelectionShape.setEnabled(false);
                this.mSelectionShape.visibility = 0;
                this.mSelectionShape.material = this.mRoomManager.wall2dMaterialDarkGrey;
            }
            else {
                this.mSelectionShape.setEnabled(pVisible);
                this.mSelectionShape.visibility = pVisible ? 0.5 : 0;
                this.mSelectionShape.material = pMainWall ? this.mRoomManager.wall2dMaterialSelected : this.mRoomManager.wall2dMaterialDarkGrey;
            }
            if (!this.m3dWallVisible && !this.isSelected)
                this.mSelectionShape.setEnabled(false);
        }
    }
    setView() {
        if (this.mView == null) {
            let tView = this.mRoomManager.view;
            if (tView != null) {
                this.mView = tView;
            }
        }
        if (this.mView != null) {
            this.mRoomManager.app.viewer.scene.onBeforeCameraRenderObservable.add(this.onBeforeCameraChanged);
            this.mRoomManager.app.viewer.scene.onAfterCameraRenderObservable.add(this.onAfterCameraChanged);
            this.mRoomManager.app.viewer.scene.onBeforeCameraRenderObservable.add(this._resizeMeshes);
            this.mView.cameraControl.eventCameraChanged.addListener(this._resizeMeshes);
        }
    }
    _canMove(pCheckStart, pNewPosition, pmovedWallEnding) {
        let tRes = null;
        let tcurrDistance = 0;
        let tnewDistance = 0;
        if (pCheckStart) {
            tcurrDistance = Vector2.Distance(this.mEnd, this.getMinStartPoint());
            tnewDistance = Vector2.Distance(this.mEnd, pNewPosition);
        }
        else {
            tcurrDistance = Vector2.Distance(this.mStart, this.getMaxEndPoint());
            tnewDistance = Vector2.Distance(this.mStart, pNewPosition);
        }
        if (tnewDistance < tcurrDistance) {
            if (pCheckStart) {
                tRes = {};
                tRes.position = this.getMinStartPoint();
                tRes.ending = WallEnding.Start;
                tRes.movedWallEnding = pmovedWallEnding;
            }
            else {
                tRes = {};
                tRes.position = this.getMaxEndPoint();
                tRes.ending = WallEnding.End;
                tRes.movedWallEnding = pmovedWallEnding;
            }
        }
        return (tRes);
    }
    checkPickInsertPoint(pPickPoint, pFS, pOpeningWidth, pFrameOffset) {
        let tHW = pOpeningWidth * 0.5;
        let tFO = pFrameOffset;
        let tDir = (pFS.end.subtract(pFS.start)).normalize();
        let tdistStart = Vector2.Distance(pFS.start, pPickPoint);
        let tdistEnd = Vector2.Distance(pFS.end, pPickPoint);
        if (tdistStart >= tHW && tdistEnd >= tHW)
            return (pPickPoint);
        if (tdistStart <= tdistEnd) {
            tHW = pFS.openingStart ? tHW + tFO : tHW;
            let tinsertPoint = pFS.start.add(tDir.scale(tHW));
            return (tinsertPoint);
        }
        {
            tHW = pFS.openingEnd ? tHW + tFO : tHW;
            let tinsertPoint = pFS.end.subtract(tDir.scale(tHW));
            return (tinsertPoint);
        }
    }
    async changeTextureRotation(pMaterialSet, pValue) {
        pMaterialSet.rotation = pValue;
        // clone texture if rotation is != 0
        if (pMaterialSet.rotation !== 0)
            await this.mRoomManager.checkMaterial(pMaterialSet);
        this.updateGeometry();
        this.notifyChange(ElementChangedFlags.PropertyValues);
        return (Promise.resolve(true));
    }
    createPickPlane() {
        let tDir = this.mEnd.subtract(this.mStart).normalize();
        let tnormal = Util.to3d((perpendicularVector2(tDir)).scale(0.5));
        let tPickPlane = Plane.FromPositionAndNormal(Util.to3d(this.mStart), tnormal);
        tPickPlane.normalize();
        this.mPickPlane = tPickPlane;
    }
    // tslint:disable-next-line:cyclomatic-complexity
    updateEndingPosition(pUpdateEndToEnd) {
        let tRes = null;
        let tBadCut;
        let tV;
        let tFeedback = false;
        //start connection
        if (this.mStartCxn.wall != null) {
            tBadCut = false;
            let tW = this.mStartCxn.wall;
            if (!this.isWallParallel(tW))
                tBadCut = false;
            if (Util.vectorEquals2(tW.mStart, tW.mEnd))
                tV = this.mStart;
            else
                tV = intersectLineLine2(this.mStart, this.mEnd, tW.mStart, tW.mEnd);
            if (tV == null || tBadCut) {
                if (this.mStartCxn.wallEnding != null && pUpdateEndToEnd && !tFeedback)
                    this._setConnection(WallEnding.Start, null, null);
            }
            else if (!Util.vectorEquals2(this.mEnd, tV)) {
                this.mStart.copyFrom(tV);
            }
            if (this.mStartCxn.wallEnding != null && pUpdateEndToEnd) {
                if (tW.mStartCxn.wall === this && !Util.vectorEquals2(tW.mEnd, this.mStart)) {
                    if (tRes == null)
                        tRes = tW._canMove(true, this.mStart, WallEnding.Start);
                    tW.mStart.copyFrom(this.mStart);
                }
                else if (tW.mEndCxn.wall === this && !Util.vectorEquals2(tW.mStart, this.mStart)) {
                    if (tRes == null)
                        tRes = tW._canMove(false, this.mStart, WallEnding.Start);
                    tW.mEnd.copyFrom(this.mStart);
                }
                if (tW.mStartCxn.wall === this && Util.vectorEquals2(tW.mEnd, this.mStart)) {
                    if (tRes == null)
                        tRes = tW._canMove(true, this.mStart, WallEnding.Start);
                }
                else if (tW.mEndCxn.wall === this && Util.vectorEquals2(tW.mStart, this.mStart) && tRes == null) {
                    tRes = tW._canMove(false, this.mStart, WallEnding.Start);
                }
                this.updateEdges();
                tW.cutEdges();
                tW.updateGeometry();
            }
        }
        //end connection
        if (this.mEndCxn.wall != null) {
            tBadCut = false;
            let tW = this.mEndCxn.wall;
            if (!this.isWallParallel(tW))
                tBadCut = false;
            if (Util.vectorEquals2(tW.mStart, tW.mEnd))
                tV = this.mEnd;
            else
                tV = intersectLineLine2(this.mStart, this.mEnd, tW.mStart, tW.mEnd);
            if (tV == null || tBadCut) {
                if (this.mEndCxn.wallEnding != null && pUpdateEndToEnd && !tFeedback)
                    this._setConnection(WallEnding.End, null, null);
            }
            else if (!Util.vectorEquals2(this.mStart, tV)) {
                this.mEnd.copyFrom(tV);
            }
            if (this.mEndCxn.wallEnding != null && pUpdateEndToEnd) {
                if (tW.mStartCxn.wall === this && !Util.vectorEquals2(tW.mEnd, this.mEnd)) {
                    if (tRes == null)
                        tRes = tW._canMove(true, this.mEnd, WallEnding.End);
                    tW.mStart.copyFrom(this.mEnd);
                }
                else if (tW.mEndCxn.wall === this && !Util.vectorEquals2(tW.mStart, this.mEnd)) {
                    if (tRes == null)
                        tRes = tW._canMove(false, this.mEnd, WallEnding.End);
                    tW.mEnd.copyFrom(this.mEnd);
                }
                if (tW.mStartCxn.wall === this && Util.vectorEquals2(tW.mEnd, this.mEnd)) {
                    if (tRes == null)
                        tRes = tW._canMove(true, this.mEnd, WallEnding.End);
                }
                else if (tW.mEndCxn.wall === this && Util.vectorEquals2(tW.mStart, this.mEnd) && tRes == null) {
                    tRes = tW._canMove(false, this.mEnd, WallEnding.End);
                }
                this.updateEdges();
                tW.cutEdges();
                tW.updateGeometry();
            }
        }
        return (tRes);
    }
    updateTransformMatrix() {
        let tMRot = Matrix.RotationY(-this.getWallAngle());
        let tMTrans = Matrix.Translation(this.mStart.x, 0.0, this.mStart.y);
        this.mHandleTansformationChange = false;
        this.setTransform(tMRot.multiply(tMTrans));
        this.mHandleTansformationChange = true;
        //update local edges
        let tTransInv = this.transformInverted;
        for (let i = 0; i < 4; ++i) {
            Vector3.TransformCoordinatesToRef(Util.to3d(this.mEdges[i]), tTransInv, gTmpVector3_1);
            this.mLocalEdges[i] = Util.to2d(gTmpVector3_1);
        }
        //update wall openings
        for (let tOpening of this.mOpenings) {
            tOpening.updateAttachedPosition(false);
        }
        //update wall additions
        for (let tAddition of this.mAdditions)
            tAddition.updateAttachedPosition(false);
    }
    updateEdges() {
        let tHT = this.mThickness / 2.0;
        let tAngle = this.getWallAngle();
        let tCosA = Math.cos(tAngle);
        let tSinA = Math.sin(tAngle);
        this.mEdges[0].set(this.mStart.x + (tHT * tSinA), this.mStart.y - (tHT * tCosA));
        this.mEdges[3].set(this.mStart.x - (tHT * tSinA), this.mStart.y + (tHT * tCosA));
        this.mEdges[1].set(this.mEnd.x + (tHT * tSinA), this.mEnd.y - (tHT * tCosA));
        this.mEdges[2].set(this.mEnd.x - (tHT * tSinA), this.mEnd.y + (tHT * tCosA));
        for (let i = 0; i < 4; ++i)
            this.mUnCutEdges[i].copyFrom(this.mEdges[i]);
    }
    checkRaySelfShot(pHits) {
        let tRes = false;
        for (let tHit of pHits) {
            if (tHit.pickedMesh !== null) {
                let twId = tHit.pickedMesh.name.replace("room:wall|", "");
                if (twId === this.id.toString()) {
                    tRes = true;
                    break;
                }
            }
        }
        return (tRes);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    cutEdges() {
        let tBadCut1;
        let tBadCut2;
        let tRes = 0;
        this.updateEdges();
        this.mStartCxn.badCut = false;
        this.mEndCxn.badCut = false;
        //start connection
        if (this.mStartCxn.wall != null) {
            this.mStartCxn.badCut = false;
            tBadCut1 = true;
            tBadCut2 = true;
            let tW = this.mStartCxn.wall;
            if (!this.isWallParallel(tW)) {
                let tV1 = Vector2.Zero();
                let tV2 = Vector2.Zero();
                //ent to end
                if (this.mStartCxn.wallEnding != null) {
                    if (tW.mStartCxn.wall === this) {
                        tBadCut1 = this.calcCutPointToRef(tW, 0, 1, 3, 2, tV1);
                        tBadCut2 = this.calcCutPointToRef(tW, 3, 2, 0, 1, tV2);
                    }
                    else if (tW.mEndCxn.wall === this) {
                        tBadCut1 = this.calcCutPointToRef(tW, 0, 1, 1, 0, tV1);
                        tBadCut2 = this.calcCutPointToRef(tW, 3, 2, 2, 3, tV2);
                    }
                }
                else 
                //side connection
                if (tW.isWallOnLeftSide(this)) {
                    tBadCut1 = this.calcSideCutPointToRef(tW, 0, 1, 2, 3, tV1);
                    tBadCut2 = this.calcSideCutPointToRef(tW, 3, 2, 2, 3, tV2);
                }
                else if (tW.isWallOnRightSide(this)) {
                    tBadCut1 = this.calcSideCutPointToRef(tW, 0, 1, 1, 0, tV1);
                    tBadCut2 = this.calcSideCutPointToRef(tW, 3, 2, 1, 0, tV2);
                }
                if (!(tBadCut1 || tBadCut2)) {
                    this.mStartCxn.badCut = false;
                    this.mEdges[0] = tV1;
                    this.mEdges[3] = tV2;
                }
                else {
                    tRes += 1;
                }
            }
        }
        //end connection
        if (this.mEndCxn.wall != null) {
            this.mEndCxn.badCut = false;
            tBadCut1 = true;
            tBadCut2 = true;
            let tW = this.mEndCxn.wall;
            if (!this.isWallParallel(tW)) {
                let tV1 = Vector2.Zero();
                let tV2 = Vector2.Zero();
                //end to end
                if (this.mEndCxn.wallEnding != null) {
                    if (tW.mStartCxn.wall === this) {
                        tBadCut1 = this.calcCutPointToRef(tW, 1, 0, 0, 1, tV1);
                        tBadCut2 = this.calcCutPointToRef(tW, 2, 3, 3, 2, tV2);
                    }
                    else if (tW.mEndCxn.wall === this) {
                        tBadCut1 = this.calcCutPointToRef(tW, 1, 0, 2, 3, tV1);
                        tBadCut2 = this.calcCutPointToRef(tW, 2, 3, 1, 0, tV2);
                    }
                }
                else if (tW.isWallOnLeftSide(this)) {
                    tBadCut1 = this.calcSideCutPointToRef(tW, 1, 0, 3, 2, tV1);
                    tBadCut2 = this.calcSideCutPointToRef(tW, 2, 3, 3, 2, tV2);
                }
                else if (tW.isWallOnRightSide(this)) {
                    tBadCut1 = this.calcSideCutPointToRef(tW, 1, 0, 0, 1, tV1);
                    tBadCut2 = this.calcSideCutPointToRef(tW, 2, 3, 0, 1, tV2);
                }
                if (!(tBadCut1 || tBadCut2)) {
                    this.mEndCxn.badCut = false;
                    this.mEdges[1] = tV1;
                    this.mEdges[2] = tV2;
                }
                else {
                    tRes += 2;
                }
            }
        }
        // calc ray points
        this.calcRayPositions();
        return (tRes);
    }
    calcRayPositions() {
        let twallDir = this.wallDirection.clone();
        let tdR = new Vector2(twallDir.y, -twallDir.x).normalize().scale(0.0001);
        let tdL = new Vector2(-twallDir.y, twallDir.x).normalize().scale(0.0001);
        let tWall_right = (this.mEdges[1].subtract(this.mEdges[0])).normalize();
        let tWL_right = Vector2.Distance(this.mEdges[0], this.mEdges[1]);
        let tWall_left = (this.mEdges[2].subtract(this.mEdges[3])).normalize();
        let tWL_left = Vector2.Distance(this.mEdges[3], this.mEdges[2]);
        this.mRayPoints = [];
        for (let i = 0.125; i < 0.9; i += 0.375) {
            let tRP_right = (this.mEdges[0].add(tWall_right.scale(tWL_right * i))).add(tdR);
            // ray from ground
            let tRPv3_right_l = new Vector3(tRP_right.x, 0.05, tRP_right.y);
            let tRPv3_right_h = new Vector3(tRP_right.x, this.mHeight - 0.05, tRP_right.y);
            this.mRayPoints.push(tRPv3_right_l);
            this.mRayPoints.push(tRPv3_right_h);
        }
        for (let i = 0.125; i < 0.9; i += 0.375) {
            let tRP_left = (this.mEdges[3].add(tWall_left.scale(tWL_left * i))).add(tdL);
            // ray from ground
            let tRPv3_left_l = new Vector3(tRP_left.x, 0.05, tRP_left.y);
            let tRPv3_left_h = new Vector3(tRP_left.x, this.mHeight - 0.05, tRP_left.y);
            this.mRayPoints.push(tRPv3_left_l);
            this.mRayPoints.push(tRPv3_left_h);
        }
    }
    calcCutPointToRef(pW2, pW1E1, pW1E2, pW2E1, pW2E2, pResult) {
        let tBadCut = false;
        //calculate cut Point
        let tVCut = intersectLineLine2(this.mUnCutEdges[pW1E1], this.mUnCutEdges[pW1E2], pW2.mUnCutEdges[pW2E1], pW2.mUnCutEdges[pW2E2]);
        if (tVCut == null)
            return (false);
        /////////
        //handle special cases (short walls, thin walls etc.)
        //checks if one side of a wall is to short (would change its direction)
        let tV1 = tVCut.subtract(this.mUnCutEdges[pW1E2]).normalize();
        let tV2 = this.mUnCutEdges[pW1E1].subtract(this.mUnCutEdges[pW1E2]).normalize();
        let tV3 = tVCut.subtract(pW2.mUnCutEdges[pW2E2]).normalize();
        let tV4 = pW2.mUnCutEdges[pW2E1].subtract(pW2.mUnCutEdges[pW2E2]).normalize();
        let t12Equal = Util.vectorEquals2(tV1, tV2);
        let t34Equal = Util.vectorEquals2(tV3, tV4);
        if (!t12Equal && !t34Equal) {
            if (this.getWallLengthBase() > pW2.getWallLengthBase()) {
                tVCut = pW2.mUnCutEdges[pW2E2];
            }
            else {
                tVCut = this.mUnCutEdges[pW1E1];
            }
            tBadCut = true;
        }
        else {
            if (!t12Equal) {
                tVCut = this.mUnCutEdges[pW1E1];
                tBadCut = true;
            }
            if (!t34Equal) {
                tVCut = pW2.mUnCutEdges[pW2E2];
                tBadCut = true;
            }
        }
        //////////
        pResult.copyFrom(tVCut);
        return (tBadCut);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getNextStart(pSource, pOpening) {
        let tminDist = Vector2.Distance(pSource, this.mEnd);
        let tRes = null;
        if (pOpening) {
            for (let tOpening of this.mOpenings) {
                let tDir = (tOpening.startPoint.subtract(pSource)).normalize();
                if (!Util.vectorEquals2(tDir, this.wallDirection, 0.00001) &&
                    !Util.vectorEquals2(tDir, Vector2.Zero(), 0.00001))
                    continue;
                let tStartDist = Vector2.Distance(tOpening.startPoint, pSource);
                if (tStartDist >= 0 && tStartDist < tminDist) {
                    tminDist = tStartDist;
                    tRes = tOpening;
                }
            }
        }
        else {
            for (let tAddition of this.mAdditions) {
                let tDir = (tAddition.startPoint.subtract(pSource)).normalize();
                if (!Util.vectorEquals2(tDir, this.wallDirection, 0.00001) &&
                    !Util.vectorEquals2(tDir, Vector2.Zero(), 0.00001))
                    continue;
                let tStartDist = Vector2.Distance(tAddition.startPoint, pSource);
                if (tStartDist >= 0 && tStartDist < tminDist) {
                    tminDist = tStartDist;
                    tRes = tAddition;
                }
            }
        }
        return (tRes);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getEndUsedSpace(pElement, pOpening) {
        let tRes = pElement;
        let tmaxDist = 0;
        if (pOpening) {
            for (let tOpening of this.mOpenings) {
                let tDir = (tOpening.endPoint.subtract(pElement.endPoint)).normalize();
                if (!Util.vectorEquals2(tDir, this.wallDirection, 0.00001))
                    continue;
                let tEndDist = Vector2.Distance(tOpening.endPoint, pElement.endPoint);
                let tstartOnCurrOpening = isPointOnSegment2(tOpening.startPoint, pElement.startPoint, pElement.endPoint);
                if (tEndDist > 0 && tEndDist > tmaxDist && tstartOnCurrOpening) {
                    tmaxDist = tEndDist;
                    tRes = tOpening;
                }
            }
        }
        else {
            for (let tAddition of this.mAdditions) {
                let tDir = (tAddition.endPoint.subtract(pElement.endPoint)).normalize();
                if (!Util.vectorEquals2(tDir, this.wallDirection, 0.00001))
                    continue;
                let tEndDist = Vector2.Distance(tAddition.endPoint, pElement.endPoint);
                let tstartOnCurrOpening = isPointOnSegment2(tAddition.startPoint, pElement.startPoint, pElement.endPoint);
                if (tEndDist > 0 && tEndDist > tmaxDist && tstartOnCurrOpening) {
                    tmaxDist = tEndDist;
                    tRes = tAddition;
                }
            }
        }
        if (tRes !== pElement)
            tRes = this.getEndUsedSpace(tRes, pOpening);
        return (tRes);
    }
    checkFreeWallSpace(pOpening = true, pComparePosition) {
        this.mFreeSpace = [];
        this._getFreeSpace(this.mStart, false, pOpening, pComparePosition);
        let tTempA = Vector2.Zero();
        let tTempB = Vector2.Zero();
        this.mFreeSpace.sort((a, b) => {
            tTempA.x = a.wallCenterDistance > 0.0 ? a.wallCenterDistance * 0.97 : a.wallCenterDistance * 0.98;
            tTempB.x = b.wallCenterDistance > 0.0 ? b.wallCenterDistance * 0.97 : b.wallCenterDistance * 0.98;
            return (tTempA.lengthSquared() - tTempB.lengthSquared());
        });
    }
    _getFreeSpace(pCheckPoint, pPointIsOpening, pOpening, pComparePosition) {
        // if (pOpening) {
        //     let tfreeSpace = this.collectFreeWallSpace_Opening();
        // }
        let tnextStart = this.getNextStart(pCheckPoint, pOpening);
        let tDist1 = 0;
        let tDist2 = 0;
        if (tnextStart != null) {
            let tnewFreeSpace = {};
            tnewFreeSpace.start = pCheckPoint;
            tnewFreeSpace.end = tnextStart.startPoint;
            tnewFreeSpace.center = Vector2.Center(tnewFreeSpace.start, tnewFreeSpace.end);
            tnewFreeSpace.openingStart = pPointIsOpening;
            tnewFreeSpace.openingEnd = true;
            tnewFreeSpace.width = Vector2.Distance(tnewFreeSpace.start, tnewFreeSpace.end);
            tDist1 = Vector2.Distance(tnewFreeSpace.start, pComparePosition);
            tDist2 = Vector2.Distance(tnewFreeSpace.end, pComparePosition);
            tnewFreeSpace.wallCenterDistance = Math.min(tDist1, tDist2);
            if (tnewFreeSpace.width > 0.20)
                this.mFreeSpace.push(tnewFreeSpace);
        }
        let tendUsed = null;
        if (tnextStart != null) {
            tendUsed = this.getEndUsedSpace(tnextStart, pOpening);
            this._getFreeSpace(tendUsed.endPoint, true, pOpening, pComparePosition);
        }
        else {
            let tnewFreeSpace = {};
            tnewFreeSpace.start = pCheckPoint;
            tnewFreeSpace.end = this.mEnd;
            tnewFreeSpace.center = Vector2.Center(tnewFreeSpace.start, tnewFreeSpace.end);
            tnewFreeSpace.openingStart = pPointIsOpening;
            tnewFreeSpace.openingEnd = false;
            tnewFreeSpace.width = Vector2.Distance(tnewFreeSpace.start, tnewFreeSpace.end);
            tDist1 = Vector2.Distance(tnewFreeSpace.start, pComparePosition);
            tDist2 = Vector2.Distance(tnewFreeSpace.end, pComparePosition);
            tnewFreeSpace.wallCenterDistance = Math.min(tDist1, tDist2);
            if (tnewFreeSpace.width > 0.20)
                this.mFreeSpace.push(tnewFreeSpace);
        }
    }
    calcSideCutPointToRef(pW2, pW1E1, pW1E2, pW2E1, pW2E2, pResult) {
        let tBadCut = false;
        //calculate cut Point
        let tVCut = intersectLineLine2(this.mUnCutEdges[pW1E1], this.mUnCutEdges[pW1E2], pW2.mUnCutEdges[pW2E1], pW2.mUnCutEdges[pW2E2]);
        if (tVCut == null)
            return (false);
        /////////
        //handle special cases (short walls, thin walls etc.)
        //checks if one side of a wall is to short (would change its direction)
        let tV1 = tVCut.subtract(this.mUnCutEdges[pW1E2]).normalize();
        let tV2 = this.mUnCutEdges[pW1E1].subtract(this.mUnCutEdges[pW1E2]).normalize();
        if (!Util.vectorEquals2(tV1, tV2)) {
            tVCut = this.mUnCutEdges[pW1E1];
            tBadCut = true;
        }
        //////////
        pResult.copyFrom(tVCut);
        return (tBadCut);
    }
    validateConnectedWalls(pMaxIterations, pCurrentIteration) {
        if (this.mStartCxn.wall != null)
            this.mStartCxn.wall._validateConnections(pMaxIterations, pCurrentIteration + 1);
        if (this.mEndCxn.wall != null)
            this.mEndCxn.wall._validateConnections(pMaxIterations, pCurrentIteration + 1);
        for (let tWall of this.mRoomManager.walls) {
            if (tWall === this || tWall === this.mStartCxn.wall || tWall === this.mEndCxn.wall)
                continue;
            if (tWall.mStartCxn.wall === this || tWall.mEndCxn.wall === this) {
                tWall._validateConnections(pMaxIterations, pCurrentIteration + 1);
            }
        }
    }
    updateConnectedWalls() {
        if (this.mStartCxn.wall != null) {
            this.mStartCxn.wall.updateEndingPosition(false);
            this.mStartCxn.wall.cutEdges();
            this.mStartCxn.wall.updateGeometry();
        }
        if (this.mEndCxn.wall != null) {
            this.mEndCxn.wall.updateEndingPosition(false);
            this.mEndCxn.wall.cutEdges();
            this.mEndCxn.wall.updateGeometry();
        }
        for (let tWall of this.mRoomManager.walls) {
            if (tWall === this || tWall === this.mStartCxn.wall || tWall === this.mEndCxn.wall)
                continue;
            if (tWall.mStartCxn.wall === this || tWall.mEndCxn.wall === this) {
                tWall.updateEndingPosition(false);
                tWall.cutEdges();
                tWall.updateGeometry();
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getNeighbours(pEnding) {
        let tResult = {
            left: null,
            right: null
        };
        let tWall = null;
        let tWalls = new Array();
        let tTempWalls = new Array();
        if (pEnding === WallEnding.Start) {
            if (this.mStartCxn.wall == null)
                return (null);
            tWall = this.mStartCxn.wall;
        }
        else {
            if (this.mEndCxn.wall == null)
                return (null);
            tWall = this.mEndCxn.wall;
        }
        if (tWall.isWallOnLeftSide(this)) {
            tWall.getAllSideWalls(tWalls, tTempWalls, true, true);
        }
        else {
            tWall.getAllSideWalls(tTempWalls, tWalls, true, true);
        }
        if (tWalls.length < 2)
            return (null);
        if (tWalls[0] !== this) {
            for (let i = 0; i < tWalls.length; ++i) {
                if (tWalls[i] === this) {
                    tResult.left = tWalls[i - 1];
                    break;
                }
            }
        }
        if (tWalls[tWalls.length - 1] !== this) {
            for (let i = 0; i < tWalls.length; ++i) {
                if (tWalls[i] === this) {
                    tResult.right = tWalls[i + 1];
                    break;
                }
            }
        }
        return (tResult);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getNeighbourDistanceEE(pEnding, pSide) {
        let tResult = {
            distance: 0,
            refPos1: null,
            refPos2: null,
            negateDir: true
        };
        let tW = null;
        // ceck conditions
        if (pEnding === WallEnding.Start) {
            if (this.mStartCxn.wall == null)
                return (null);
            tW = this.mStartCxn.wall;
        }
        else {
            if (this.mEndCxn.wall == null)
                return (null);
            tW = this.mEndCxn.wall;
        }
        if (this.isWallParallel(tW)) {
            return (null);
        }
        //find neighbour wall
        let tWN = null;
        let tV1 = Vector2.Zero();
        let tV2 = Vector2.Zero();
        let tNeg = 1;
        let tWalls = new Array();
        let tTempWalls = new Array();
        if (tW.isWallOnRightSide(this)) {
            tW.getAllSideWalls(tWalls, tTempWalls, true, true);
        }
        else {
            tW.getAllSideWalls(tTempWalls, tWalls, true, true);
        }
        if (tWalls.length > 0) {
            if (tW.mStartCxn.wall === this) {
                tWN = tWalls[0];
            }
            else {
                tWN = tWalls[tWalls.length - 1];
            }
        }
        if (tW.isWallOnLeftSide(this)) {
            if (tW.mStartCxn.wall === this) {
                if (tWN != null) {
                    if (tWN.mStartCxn.wall === tW)
                        tV1 = tWN.mEdges[0];
                    else
                        tV1 = tWN.mEdges[2];
                }
                else
                    tV1 = tW.mEdges[1];
                if (this.mStartCxn.wall === tW)
                    tV2 = this.mEdges[3];
                else
                    tV2 = this.mEdges[1];
                tNeg = -1;
            }
            else {
                if (tWN != null) {
                    if (tWN.mStartCxn.wall === tW)
                        tV1 = tWN.mEdges[3];
                    else
                        tV1 = tWN.mEdges[1];
                }
                else
                    tV1 = tW.mEdges[0];
                if (this.mStartCxn.wall === tW)
                    tV2 = this.mEdges[0];
                else
                    tV2 = this.mEdges[2];
            }
        }
        else if (tW.mStartCxn.wall === this) {
            if (tWN != null) {
                if (tWN.mStartCxn.wall === tW)
                    tV1 = tWN.mEdges[3];
                else
                    tV1 = tWN.mEdges[1];
            }
            else
                tV1 = tW.mEdges[2];
            if (this.mStartCxn.wall === tW)
                tV2 = this.mEdges[0];
            else
                tV2 = this.mEdges[2];
            tNeg = -1;
        }
        else {
            if (tWN != null) {
                if (tWN.mStartCxn.wall === tW)
                    tV1 = tWN.mEdges[0];
                else
                    tV1 = tWN.mEdges[2];
            }
            else
                tV1 = tW.mEdges[3];
            if (this.mStartCxn.wall === tW)
                tV2 = this.mEdges[3];
            else
                tV2 = this.mEdges[1];
        }
        tResult.refPos1 = tV1;
        tResult.refPos2 = tV2;
        //negate distance if necessary
        if (!Util.vectorEquals2(tV1.subtract(tV2).normalize(), tW.mStart.subtract(tW.mEnd).normalize()))
            tResult.distance = (Vector2.Distance(tV1, tV2) * -tNeg);
        else
            tResult.distance = (Vector2.Distance(tV1, tV2) * tNeg);
        if (eq(tResult.distance, 0.0))
            tResult.distance = Math.abs(tResult.distance);
        return (tResult);
    }
    getMinStartPoint() {
        let tstart = this.mEnd.subtract(this.wallDirection.scale(Wall.MINIMAL_WALL_LENGTH));
        let tDist = Vector2.Distance(this.mStart, tstart);
        for (let tOpening of this.mOpenings) {
            let t_Dist = Vector2.Distance(this.mStart, tOpening.startPoint);
            if (t_Dist < tDist) {
                tstart = tOpening.startPoint;
                tDist = t_Dist;
            }
        }
        return (tstart);
    }
    getMaxEndPoint() {
        let tend = this.mStart.add(this.wallDirection.scale(Wall.MINIMAL_WALL_LENGTH));
        let tDist = Vector2.Distance(this.mEnd, tend);
        for (let tOpening of this.mOpenings) {
            let t_Dist = Vector2.Distance(this.mEnd, tOpening.endPoint);
            if (t_Dist < tDist) {
                tend = tOpening.endPoint;
                tDist = t_Dist;
            }
        }
        return (tend);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    get2DLines(pMode) {
        if (Util.vectorEquals2(this.mStart, this.mEnd))
            return ([]);
        //this.cutEdges();
        let tLines = new Array();
        //start connection
        if (this.mStartCxn.wall == null || //|| !eq(this.mStartCxn.wall.mHeight, this.mHeight)
            (this.mStartCxn.wall != null && pMode !== Line2dMode.Wall) ||
            pMode === Line2dMode.Hatch || this.mStartCxn.badCut) {
            tLines.push({
                p1: this.mEdges[0],
                p2: this.mEdges[3]
            });
        }
        //end connection
        if (this.mEndCxn.wall == null || //|| !eq(this.mEndCxn.wall.mHeight, this.mHeight)
            (this.mEndCxn.wall != null && pMode !== Line2dMode.Wall) ||
            pMode === Line2dMode.Hatch || this.mEndCxn.badCut) {
            tLines.push({
                p1: this.mEdges[1],
                p2: this.mEdges[2]
            });
        }
        let tSectionsL = new Array();
        let tSectionsR = new Array();
        let tWallsL = new Array();
        let tWallsR = new Array();
        if (pMode !== Line2dMode.Hatch) {
            this.getAllSideWalls(tWallsL, tWallsR, false, false);
            Wall.addWallOpenSections(tSectionsL, this, tWallsL, WallSide.Left, pMode);
            Wall.addWallOpenSections(tSectionsR, this, tWallsR, WallSide.Right, pMode);
        }
        /*addWallElementOpenSections(tSectionsL, tSectionsR, pLines, this,
            mWallElements, pMode); */
        Wall.addOpenSectionLines(tSectionsL, tLines, this, WallSide.Left);
        Wall.addOpenSectionLines(tSectionsR, tLines, this, WallSide.Right);
        return (tLines);
    }
    update2dGeometry() {
        this.dispose2dMeshes();
        //hatch
        let tVertexData = new VertexData();
        tVertexData.positions = new Float32Array(12);
        tVertexData.normals = new Float32Array(12);
        tVertexData.uvs = new Float32Array(8);
        tVertexData.indices = new Uint16Array(6);
        for (let i = 0; i < 4; ++i) {
            let tI2 = i * 2;
            let tI3 = i * 3;
            tVertexData.positions[tI3 + 0] = this.mLocalEdges[i].x;
            tVertexData.positions[tI3 + 1] = 0;
            tVertexData.positions[tI3 + 2] = this.mLocalEdges[i].y;
            tVertexData.normals[tI3 + 0] = 0;
            tVertexData.normals[tI3 + 1] = 1;
            tVertexData.normals[tI3 + 2] = 0;
            tVertexData.uvs[tI2 + 0] = this.mEdges[i].x;
            tVertexData.uvs[tI2 + 1] = this.mEdges[i].y;
        }
        tVertexData.indices[0] = 0;
        tVertexData.indices[1] = 1;
        tVertexData.indices[2] = 2;
        tVertexData.indices[3] = 0;
        tVertexData.indices[4] = 2;
        tVertexData.indices[5] = 3;
        // 2d wall
        let tMesh = new Mesh("", this.mScene);
        let tGeom = new Geometry(Geometry.RandomId(), this.mScene, tVertexData);
        tGeom.applyToMesh(tMesh);
        if (this.mIsDrawingNew)
            tMesh.material = this.mRoomManager.wall2dMaterialGrey;
        else {
            tMesh.material = this.mRoomManager.wall2dMaterialDarkGrey;
            tMesh.renderingGroupId = 0;
        }
        tMesh.parent = this.mNode;
        tMesh.name = "wall_" + this.mId + "_2dwall";
        tMesh.position.y = Wall.WALL_2D_HEIHGT;
        if (this.mOpeningIsInteraction)
            tMesh.visibility = 0.5;
        else
            tMesh.visibility = 1;
        tMesh.freezeWorldMatrix();
        ShadowGenerator.disableMeshShadow(tMesh);
        this.m2dMeshes.push(tMesh);
        // visible shape for 3d selection
        if (this.mSelectionShape != null)
            this.mSelectionShape.dispose();
        this.mSelectionShape = tMesh.clone();
        this.mSelectionShape.makeGeometryUnique();
        this.mSelectionShape.material = this.mRoomManager.wall2dMaterialSelected;
        this.mSelectionShape.renderingGroupId = this.mrenderingGroupId;
        this.mSelectionShape.freezeWorldMatrix();
        this.mSelectionShape.layerMask = ViewLayerMaskFlags.All & ~ViewLayerMaskFlags.Screenshot;
        ShadowGenerator.disableMeshShadow(this.mSelectionShape);
        this.mSelectionShape.setEnabled(false);
        this.mSelectionShape.visibility = 0;
        this.mSelectionShape.isPickable = false;
        this.m2dMeshes.push(this.mSelectionShape);
        //outline
        let tLines2d = this.get2DLines(Line2dMode.Wall);
        let tLines = new Array();
        for (let tLine2d of tLines2d) {
            let tP1 = Util.to3d(tLine2d.p1);
            let tP2 = Util.to3d(tLine2d.p2);
            Vector3.TransformCoordinatesToRef(tP1, this.transformInverted, tP1);
            Vector3.TransformCoordinatesToRef(tP2, this.transformInverted, tP2);
            tLines.push([tP1, tP2]);
        }
        let tLine = CreateLineSystem("room:wall_outline", {
            lines: tLines, updatable: false, instance: null
        }, this.mScene);
        tLine.color = Color3.Black();
        tLine.isPickable = false;
        tLine.position.y = Wall.WALL_2D_HEIHGT;
        tLine.intersectionThreshold = 0;
        let tWM = this.node.getWorldMatrix();
        this.mCutLines = [];
        for (let tP of tLines) {
            let tVP0 = Vector3.TransformCoordinates(tP[0], tWM);
            let tVP1 = Vector3.TransformCoordinates(tP[1], tWM);
            this.mCutLines.push([tVP0, tVP1]);
        }
        tLine.parent = this.mNode;
        CameraControl.SetMeshCameraModeMask(tLine, null);
        tLine.freezeWorldMatrix();
        this.m2dMeshes.push(tLine);
        this.update2dVisibility();
    }
    updateCrossHair() {
        if (this.mMovePoint !== null) {
            let tCHpos = this.mMovePoint === WallEnding.Start ? this.startPoint : this.endPoint;
            WallCrossHair.updateCrossHair(tCHpos);
        }
    }
    setCrossHair(psnapped) {
        if (this.mMoveMode === WallSnapping.Mode.MoveWall)
            return;
        WallCrossHair.setCrossHair(psnapped);
    }
    setLocalVisibility(pKeepVisible) {
        this.mKeepVisible = pKeepVisible;
        this._updateVisibility(true);
        this.notifyChange(ElementChangedFlags.PropertyValues);
        this.notifyChange(ElementChangedFlags.Properties);
    }
    removeAngleArcMesh() {
        let tfound = true;
        while (tfound) {
            tfound = false;
            for (let tMesh of this.m2dMeshes) {
                if (tMesh.name === "angleArc") {
                    tfound = true;
                    removeElement(this.m2dMeshes, tMesh);
                    tMesh.dispose();
                    break;
                }
            }
        }
        if (this.mEdgeAngleData != null) {
            for (let tEAData of this.mEdgeAngleData) {
                if (tEAData.TextBlock != null)
                    tEAData.TextBlock.text = "";
                if (tEAData.TextPlane != null)
                    tEAData.TextPlane.setEnabled(false);
            }
        }
    }
    showAngleSector(pShow) {
        if (!pShow) {
            this.removeAngleArcMesh();
            if (!this.misMoving)
                return;
        }
        if (this.mKeepMesh != null) {
            this.mKeepMesh.setAbsolutePosition(this.mNode.position);
            updateFrozenWorldMatrix(this.mKeepMesh, true);
        }
        let tend = this.getWallEndArc(0);
        let tend1 = this.getWallEndArc(1);
        tend = tend.concat(tend1);
        if (tend != null && tend.length > 0) {
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < tend.length; i++) {
                let tEAData = tend[i];
                this.drawAngleSector(tEAData, i);
            }
        }
    }
    initEdgeAngleData() {
        if (this.mRoomManager.wallsLoading)
            return;
        if (this.mEdgeAngleData != null)
            return;
        this.mEdgeAngleData = Array();
        for (let i = 0; i < 4; i++) {
            let tTextPlane = CreatePlane("textPlaneArc", { width: 1, height: 1 }, this.mScene);
            let tPos = Vector3.Zero();
            tTextPlane.position = tPos;
            tTextPlane.scaling = new Vector3(1, 1, 1);
            tTextPlane.rotation.x = Math.PI / 2;
            tTextPlane.isPickable = false;
            tTextPlane.setEnabled(false);
            tTextPlane.renderingGroupId = 1;
            //plane2.rotation.y = Math.PI/1;
            tTextPlane.billboardMode = Mesh.BILLBOARDMODE_NONE;
            CameraControl.SetMeshCameraModeMask(tTextPlane, CameraModeMask.All &
                ~CameraModeMask.Perspective & ~CameraModeMask.Orthographic);
            let tTextAdvTexture = AdvancedDynamicTexture.CreateForMesh(tTextPlane);
            let tTextTextBlock = new TextBlock("but1", "45°");
            tTextTextBlock.width = 0.58;
            tTextTextBlock.height = 0.15;
            tTextTextBlock.color = "black";
            tTextTextBlock.fontSize = 200;
            tTextTextBlock.outlineWidth = 0;
            tTextTextBlock.outlineColor = "black";
            tTextTextBlock.shadowColor = "white";
            //tTextTextBlock.linkWithMesh(this.mTextPlane);
            //tTextTextBlock.hoverCursor = "pointer";
            tTextTextBlock.fontFamily = this.mRoomManager.app.theme.fontFamily;
            // by enabling the textBlock's hit tests, it becomes a button instead of a button.
            // disable if you want it un-clickable.
            tTextTextBlock.isHitTestVisible = false;
            // tTextTextBlock.onPointerUpObservable.add(() => {
            //     //alert("you did it!");
            // });
            tTextAdvTexture.addControl(tTextTextBlock);
            let tedgeAngleData = {};
            tedgeAngleData.TextPlane = tTextPlane;
            tedgeAngleData.TextAdvTexture = tTextAdvTexture;
            tedgeAngleData.TextBlock = tTextTextBlock;
            tedgeAngleData.enabled = false;
            this.mEdgeAngleData.push(tedgeAngleData);
        }
    }
    updateCircleArcText(pScaleFactor, pWallArcData, pArcIndex) {
        if (this.mEdgeAngleData == null)
            return;
        if (pArcIndex > this.mEdgeAngleData.length - 1)
            return;
        let tEAData = this.mEdgeAngleData[pArcIndex];
        tEAData.WallEndArcData = pWallArcData;
        tEAData.TextPlane.scaling = new Vector3(pScaleFactor, pScaleFactor, pScaleFactor);
        let tPos = pWallArcData.Origin;
        if (pWallArcData.BisectorDirection != null) {
            tPos = tPos.add(pWallArcData.BisectorDirection.scale(pScaleFactor * 0.3));
            tEAData.TextPlane.setAbsolutePosition(tPos);
            //tEAData.TextPlane.rotation.y = Math.PI/-5;
        }
        if (tEAData.TextBlock != null)
            tEAData.TextBlock.text = pWallArcData.angle.toFixed(1) + "°";
        if (tEAData.TextPlane != null) {
            tEAData.TextPlane.setEnabled(true);
            updateFrozenWorldMatrix(tEAData.TextPlane, true);
        }
    }
    drawAngleSector(pWallEndArcData, pIndex) {
        if (this.mView == null || this.mView.cameraControl.cameraMode === 7 || this.mView.cameraControl.cameraMode === 6)
            return;
        this.mWallArcData = pWallEndArcData;
        let tOrigin = pWallEndArcData.Origin;
        //tOrigin = tOrigin.subtract(this.mNode.position);
        let tRadius = 0.5;
        let tScaleFactor = this.getScaleFactor();
        if (tScaleFactor != null) {
            tRadius = tScaleFactor * 0.6;
            this.updateCircleArcText(tScaleFactor, pWallEndArcData, pIndex);
        }
        let tV1 = pWallEndArcData.Direction1;
        let tV2 = pWallEndArcData.Direction2;
        let cross = Vector3.Cross(tV1, tV2);
        let dot = Vector3.Dot(tV1, tV2);
        let angle = Math.acos(dot / (tV1.length() * tV2.length()));
        let points = [];
        let minNb = 20;
        let factor = 2;
        let nbPoints = Math.floor(tRadius * angle * factor);
        nbPoints = (nbPoints < minNb) ? minNb : nbPoints;
        let firstPoint = ((Vector3.Normalize(tV1)).scale(tRadius));
        let lastPoint = ((Vector3.Normalize(tV2)).scale(tRadius));
        let matrix;
        let ang = angle / nbPoints;
        let rotated;
        for (let i = 0; i < nbPoints; i++) {
            matrix = Matrix.RotationAxis(cross, ang * i);
            rotated = Vector3.TransformCoordinates(firstPoint, matrix);
            points.push(rotated.add(tOrigin));
        }
        points.push(lastPoint.add(tOrigin));
        let tcircularArcLine = CreateLines("angleArc", { points: points }, this.mScene);
        CameraControl.SetMeshCameraModeMask(tcircularArcLine, CameraModeMask.All &
            ~CameraModeMask.Perspective & ~CameraModeMask.Orthographic);
        CameraControl.SetMeshCameraModeMask(tcircularArcLine, CameraModeMask.Top |
            CameraModeMask.Bottom);
        this.m2dMeshes.push(tcircularArcLine);
        tcircularArcLine.color = Color3.Black();
    }
    // tslint:disable-next-line:cyclomatic-complexity
    update2dVisibility() {
        if (this.mSelectionShape == null)
            return;
        let tselMeshEnabled = this.mSelectionShape.isEnabled();
        for (let tMesh of this.m2dMeshes) {
            if (this.mRoomManager.viewMode === 0 || this.mRoomManager.isInteracting ||
                ((this.misHidden) ||
                    (!this.misHidden && this.mRoomManager.visibilityMode === VisibilityMode.Show2d))) {
                tMesh.setEnabled(true);
            }
            else {
                this.disable2dShadow();
                tMesh.setEnabled(false);
            }
        }
        this.mSelectionShape.setEnabled(tselMeshEnabled);
        for (let tOpening of this.mOpenings)
            tOpening._update2dVisibility();
        for (let tAddition of this.mAdditions) {
            tAddition._update2dVisibility();
        }
    }
    update3dGeometry() {
        this.dispose3dMeshes();
        //no 3d update during interaction
        if (this.mRoomManager.isInteracting) {
            this.m3dNeedsUpdate = true;
            return;
        }
        this.m3dNeedsUpdate = false;
        let tCSG = CsgUtils.extrudeWall(this);
        if (tCSG == null)
            return;
        // for dummy wall side object
        this.mSidePolygons = CsgUtils.getSidePolygons(this);
        //cut opening holes
        for (let tOpening of this.mOpenings) {
            let tCutObj = tOpening.getCSGCutObject();
            if (tCutObj != null)
                tCSG = tCSG.subtractSub(tCutObj, false, false);
        }
        tCSG = tCSG.reTesselated().canonicalized();
        //create meshes
        let tMeshes = CsgUtils.buildMeshes(tCSG, this.mScene);
        if (tMeshes != null) {
            for (let tMesh of tMeshes) {
                if (tMesh.material == null)
                    tMesh.material = this.mRoomManager.wallDefaultMaterial;
                tMesh.parent = this.mNode;
                tMesh.name = "room:wall|" + this.mId.toString();
                tMesh.freezeWorldMatrix();
                tMesh.visibility = this.mRoomManager.wallOpacity;
                tMesh.receiveShadows = true;
                //not visible in top and bottom view
                CameraControl.SetMeshCameraModeMask(tMesh, CameraModeMask.All &
                    ~CameraModeMask.Top & ~CameraModeMask.Bottom);
                this.m3dMeshes.push(tMesh);
            }
        }
        this.updateSideWallDummies();
        this.update3dVisibility(false);
    }
    updateSideWallDummies() {
        if (this.mWallSideDummy_L != null) {
            if (this.mSidePolygons[0] != null) {
                this.mWallSideDummy_L.setWallSidePolygon(this.mSidePolygons[0]);
            }
            this.mWallSideDummy_L.updateGeometry_GEO();
        }
        if (this.mWallSideDummy_R != null) {
            if (this.mSidePolygons[1] != null) {
                this.mWallSideDummy_R.setWallSidePolygon(this.mSidePolygons[1]);
            }
            this.mWallSideDummy_R.updateGeometry_GEO();
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    update3dVisibility(pUpdateOpenings) {
        for (let tMesh of this.m3dMeshes) {
            if (this.mRoomManager.viewMode === 0 ||
                this.mRoomManager.visibilityMode === VisibilityMode.Show2d ||
                ((this.mRoomManager.visibilityMode === VisibilityMode.Show3d) && this.misHidden)) {
                if (this.mKeepVisible) {
                    tMesh.setEnabled(true);
                    this.m3dWallVisible = true;
                }
                else {
                    this.disable2dShadow();
                    tMesh.setEnabled(false);
                    this.m3dWallVisible = false;
                }
            }
            else {
                tMesh.setEnabled(true);
                this.m3dWallVisible = true;
            }
        }
        if (this.mSelectionShapeActive) {
            if (this.m3dWallVisible)
                this.mSelectionShape.setEnabled(true);
            else if (this.isSelected)
                this.mSelectionShape.setEnabled(true);
            else
                this.mSelectionShape.setEnabled(false);
        }
        else {
            this.mSelectionShape.setEnabled(false);
        }
        if (pUpdateOpenings) {
            for (let tOpening of this.mOpenings)
                tOpening._update3dVisibility();
            for (let tAddition of this.mAdditions)
                tAddition._update3dVisibility();
        }
    }
    updateMaterial_A() {
        let tmatId = this.mRoomManager.getMaterialId(this.mMaterialA);
        let tMat = null;
        if (this.mMaterialA.rotation === 0) {
            tMat = this.mRoomManager.MatManager.getMaterial(tmatId);
        }
        else {
            tmatId = tmatId + this.mMaterialA.idAddOn;
            tMat = this.mRoomManager.MatManager.getMaterial(tmatId);
        }
        if (tMat != null) {
            this.updateTexture(tMat, this.mMaterialA);
            return;
        }
    }
    updateMaterial_B() {
        let tmatId = this.mRoomManager.getMaterialId(this.mMaterialB);
        let tMat = null;
        if (this.mMaterialB.rotation === 0) {
            tMat = this.mRoomManager.MatManager.getMaterial(tmatId);
        }
        else {
            tmatId = tmatId + this.mMaterialB.idAddOn;
            tMat = this.mRoomManager.MatManager.getMaterial(tmatId);
        }
        if (tMat != null) {
            this.updateTexture(tMat, this.mMaterialB);
            return;
        }
    }
    updateTexture(pMaterial, pMatSet) {
        if (pMatSet.rotation === 0)
            return;
        let trotAngle = degToRad(pMatSet.rotation);
        pMaterial.unfreeze();
        if (pMaterial.albedoTexture != null) {
            pMaterial.albedoTexture.wAng = trotAngle;
            pMaterial.albedoTexture.notifyTextureMatrixChanged();
        }
        if (pMaterial.bumpTexture != null) {
            pMaterial.bumpTexture.wAng = trotAngle;
            pMaterial.bumpTexture.notifyTextureMatrixChanged();
        }
        if (pMaterial.metallicTexture != null) {
            pMaterial.metallicTexture.wAng = trotAngle;
            pMaterial.metallicTexture.notifyTextureMatrixChanged();
        }
        if (pMaterial.microSurfaceTexture != null) {
            pMaterial.microSurfaceTexture.wAng = trotAngle;
            pMaterial.microSurfaceTexture.notifyTextureMatrixChanged();
        }
        pMaterial.freeze();
    }
    updateMaterial() {
        this.updateMaterial_A();
        this.updateMaterial_B();
    }
    dispose2dMeshes() {
        if (this.m2dMeshes.length === 0)
            return;
        for (let tMesh of this.m2dMeshes)
            tMesh.dispose();
        this.m2dMeshes = new Array();
        if (this.mSelectionShape !== null) {
            this.mSelectionShape.setEnabled(false);
            this.mSelectionShape.dispose();
        }
    }
    dispose3dMeshes() {
        if (this.m3dMeshes.length === 0)
            return;
        for (let tMesh of this.m3dMeshes)
            tMesh.dispose();
        this.m3dMeshes = new Array();
    }
    /**
     * Filters only needed mesh for automatic wall fade out
     */
    wallFilter(pMesh) {
        let tname = pMesh.name;
        if ((tname.indexOf("room:wall") === 0) || tname.indexOf("room:wallopening") === 0)
            return (true);
        return (false);
    }
    getCameraSide() {
        let tDir = this.mEnd.subtract(this.mStart).normalize();
        let tright = (perpendicularVector2(tDir)).scale(0.5);
        let tleft = Util.invert2d(tright);
        let twallCenter = Util.to3d(Vector2.Center(this.mStart, this.mEnd));
        let tView = this.mRoomManager.view;
        if (tView === null)
            return (0);
        let tdistR = Vector3.Distance(twallCenter.add(Util.to3d(tright)), tView.cameraControl.position);
        let tdistL = Vector3.Distance(twallCenter.add(Util.to3d(tleft)), tView.cameraControl.position);
        if (tdistR <= tdistL)
            return (0);
        return (1);
    }
    getWallPointOfPickPoint(pPickPos) {
        let tPV = perpendicularVector2(this.wallDirection).normalize();
        let tPV_invert = Util.invert2d(tPV);
        let tP1 = Util.to2d(pPickPos).add(tPV.scale(1));
        let tP2 = Util.to2d(pPickPos).add(tPV_invert.scale(1));
        let tIntersects = Util.getLineIntersectionPoint(this.mStart.x, this.mStart.y, this.mEnd.x, this.mEnd.y, tP1.x, tP1.y, tP2.x, tP2.y);
        if (tIntersects instanceof Vector2)
            return (tIntersects);
        return (Util.to2d(pPickPos));
    }
    getWallMaterialId_L() {
        let tRes = this.mRoomManager._wallColors[0];
        let ttmp = this.mMaterialB.category + this.mRoomManager.materialSplitStr + this.mMaterialB.value;
        if (ttmp.indexOf(this.mRoomManager.materialSplitStr) === 0)
            tRes = this.mMaterialB.value;
        else
            tRes = ttmp;
        return (tRes);
    }
    findEdgeIntersection(pDir1, pDir2, pOrigin) {
        let tRes = null;
        let tangleBisector = Util.to2d(pDir1.add(pDir2));
        let torigin2d = Util.to2d(pOrigin);
        let torigin2d_add = torigin2d.add(tangleBisector.scale(5));
        let tminAngle = 180;
        for (let tP of this.mEdges) {
            let tedgeDir = tP.subtract(torigin2d);
            let tcompareAngle = radToDeg(angleBetweenVectors2(tangleBisector, tedgeDir));
            if (tcompareAngle <= tminAngle) {
                tminAngle = tcompareAngle;
                tRes = Util.to3d(tP);
            }
            // let tintersectPoint = isPointOnSegment2(tP, torigin2d, torigin2d_add);
            // if (tintersectPoint) {
            //     tRes = Util.to3d(tP);
            //     return (tRes);
            // }
        }
        return (tRes);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getWallEndArc(pWallEnding) {
        let tRes = [];
        let tCxn = pWallEnding === WallEnding.Start ? this.mStartCxn : this.mEndCxn;
        if (tCxn.wall == null)
            return (tRes);
        let tDir2d = Vector3.Zero();
        let tarcData = {};
        let tcxnWallStart = tCxn.wall.mStart;
        let tcxnWallEnd = tCxn.wall.mEnd;
        let tintersectP = Vector2.Zero();
        let tintEdge = null;
        let tangle = 0;
        let tsignedAngle = 0;
        if (pWallEnding === WallEnding.Start) {
            tDir2d = Util.to3d((this.mEnd.subtract(this.mStart)).normalize());
            tarcData.Direction1 = tDir2d;
            if (Util.vectorEquals2(this.mStart, tcxnWallStart)) {
                tDir2d = Util.to3d((tcxnWallEnd.subtract(tcxnWallStart)).normalize());
                tarcData.Direction2 = tDir2d;
                tarcData.Origin = Util.to3d(this.mStart);
                tintEdge = this.findEdgeIntersection(tarcData.Direction1, tarcData.Direction2, tarcData.Origin);
                if (tintEdge != null) {
                    tarcData.BisectorDirection = (tintEdge.subtract(tarcData.Origin)).normalize();
                    tarcData.Origin = tintEdge;
                }
                else {
                    tarcData.BisectorDirection = null;
                }
                tangle = angleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tsignedAngle = signedAngleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tarcData.angle = radToDeg(tangle);
                tarcData.signedAngle = radToDeg(tsignedAngle);
                tRes.push(tarcData);
                return (tRes);
            }
            if (Util.vectorEquals2(this.mStart, tcxnWallEnd)) {
                tDir2d = Util.to3d((tcxnWallStart.subtract(tcxnWallEnd)).normalize());
                tarcData.Direction2 = tDir2d;
                tarcData.Origin = Util.to3d(this.mStart);
                tintEdge = this.findEdgeIntersection(tarcData.Direction1, tarcData.Direction2, tarcData.Origin);
                if (tintEdge != null) {
                    tarcData.BisectorDirection = (tintEdge.subtract(tarcData.Origin)).normalize();
                    tarcData.Origin = tintEdge;
                }
                else {
                    tarcData.BisectorDirection = null;
                }
                tangle = angleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tsignedAngle = signedAngleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tarcData.angle = radToDeg(tangle);
                tarcData.signedAngle = radToDeg(tsignedAngle);
                tRes.push(tarcData);
                return (tRes);
            }
            if (isPointOnSegment2(this.mStart, tcxnWallStart, tcxnWallEnd)) {
                tintersectP = intersectLineLine2(tcxnWallStart, tcxnWallEnd, this.mStart, this.mEnd);
                if (tintersectP == null)
                    return (tRes);
                // line 1 to tintersectP
                tDir2d = Util.to3d((tcxnWallStart.subtract(tintersectP)).normalize());
                tarcData.Direction2 = tDir2d;
                tarcData.Origin = Util.to3d(tintersectP.clone());
                tintEdge = this.findEdgeIntersection(tarcData.Direction1, tarcData.Direction2, tarcData.Origin);
                if (tintEdge != null) {
                    tarcData.BisectorDirection = (tintEdge.subtract(tarcData.Origin)).normalize();
                    tarcData.Origin = tintEdge;
                }
                else {
                    tarcData.BisectorDirection = null;
                }
                tangle = angleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tsignedAngle = signedAngleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tarcData.angle = radToDeg(tangle);
                tarcData.signedAngle = radToDeg(tsignedAngle);
                tRes.push(tarcData);
                // line 2 to tintersectP
                let tarcData2 = {};
                tDir2d = Util.to3d((tcxnWallEnd.subtract(tintersectP)).normalize());
                tarcData2.Direction1 = tarcData.Direction1.clone();
                tarcData2.Direction2 = tDir2d;
                tarcData2.Origin = Util.to3d(tintersectP.clone());
                tintEdge = this.findEdgeIntersection(tarcData2.Direction1, tarcData2.Direction2, tarcData2.Origin);
                if (tintEdge != null) {
                    tarcData2.BisectorDirection = (tintEdge.subtract(tarcData2.Origin)).normalize();
                    tarcData2.Origin = tintEdge;
                }
                else {
                    tarcData2.BisectorDirection = null;
                }
                tangle = angleBetweenVectors2(Util.to2d(tarcData2.Direction1), Util.to2d(tarcData2.Direction2));
                tsignedAngle = signedAngleBetweenVectors2(Util.to2d(tarcData2.Direction1), Util.to2d(tarcData2.Direction2));
                tarcData2.angle = radToDeg(tangle);
                tarcData2.signedAngle = radToDeg(tsignedAngle);
                tRes.push(tarcData2);
                return (tRes);
            }
        }
        if (pWallEnding === WallEnding.End) {
            tDir2d = Util.to3d((this.mStart.subtract(this.mEnd)).normalize());
            tarcData.Direction1 = tDir2d;
            if (Util.vectorEquals2(this.mEnd, tcxnWallStart)) {
                tDir2d = Util.to3d(tcxnWallEnd.subtract(tcxnWallStart).normalize());
                tarcData.Direction2 = tDir2d;
                tarcData.Origin = Util.to3d(this.mEnd);
                tintEdge = this.findEdgeIntersection(tarcData.Direction1, tarcData.Direction2, tarcData.Origin);
                if (tintEdge != null) {
                    tarcData.BisectorDirection = (tintEdge.subtract(tarcData.Origin)).normalize();
                    tarcData.Origin = tintEdge;
                }
                else {
                    tarcData.BisectorDirection = null;
                }
                tangle = angleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tsignedAngle = signedAngleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tarcData.angle = radToDeg(tangle);
                tarcData.signedAngle = radToDeg(tsignedAngle);
                tRes.push(tarcData);
                return (tRes);
            }
            if (Util.vectorEquals2(this.mEnd, tcxnWallEnd)) {
                tDir2d = Util.to3d(tcxnWallStart.subtract(tcxnWallEnd).normalize());
                tarcData.Direction2 = tDir2d;
                tarcData.Origin = Util.to3d(this.mEnd);
                tintEdge = this.findEdgeIntersection(tarcData.Direction1, tarcData.Direction2, tarcData.Origin);
                if (tintEdge != null) {
                    tarcData.BisectorDirection = (tintEdge.subtract(tarcData.Origin)).normalize();
                    tarcData.Origin = tintEdge;
                }
                else {
                    tarcData.BisectorDirection = null;
                }
                tangle = angleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tsignedAngle = signedAngleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tarcData.angle = radToDeg(tangle);
                tarcData.signedAngle = radToDeg(tsignedAngle);
                tRes.push(tarcData);
                return (tRes);
            }
            if (isPointOnSegment2(this.mEnd, tcxnWallStart, tcxnWallEnd)) {
                tintersectP = intersectLineLine2(tcxnWallStart, tcxnWallEnd, this.mStart, this.mEnd);
                if (tintersectP == null)
                    return (tRes);
                // line 1 to tintersectP
                tDir2d = Util.to3d((tcxnWallStart.subtract(tintersectP)).normalize());
                tarcData.Direction2 = tDir2d;
                tarcData.Origin = Util.to3d(tintersectP.clone());
                tintEdge = this.findEdgeIntersection(tarcData.Direction1, tarcData.Direction2, tarcData.Origin);
                if (tintEdge != null) {
                    tarcData.BisectorDirection = (tintEdge.subtract(tarcData.Origin)).normalize();
                    tarcData.Origin = tintEdge;
                }
                else {
                    tarcData.BisectorDirection = null;
                }
                tangle = angleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tsignedAngle = signedAngleBetweenVectors2(Util.to2d(tarcData.Direction1), Util.to2d(tarcData.Direction2));
                tarcData.angle = radToDeg(tangle);
                tarcData.signedAngle = radToDeg(tsignedAngle);
                tRes.push(tarcData);
                // line 2 to tintersectP
                let tarcData2 = {};
                tDir2d = Util.to3d((tcxnWallEnd.subtract(tintersectP)).normalize());
                tarcData2.Direction1 = tarcData.Direction1.clone();
                tarcData2.Direction2 = tDir2d;
                tarcData2.Origin = Util.to3d(tintersectP.clone());
                tintEdge = this.findEdgeIntersection(tarcData2.Direction1, tarcData2.Direction2, tarcData2.Origin);
                if (tintEdge != null) {
                    tarcData2.BisectorDirection = (tintEdge.subtract(tarcData2.Origin)).normalize();
                    tarcData2.Origin = tintEdge;
                }
                else {
                    tarcData2.BisectorDirection = null;
                }
                tangle = angleBetweenVectors2(Util.to2d(tarcData2.Direction1), Util.to2d(tarcData2.Direction2));
                tsignedAngle = signedAngleBetweenVectors2(Util.to2d(tarcData2.Direction1), Util.to2d(tarcData2.Direction2));
                tarcData2.angle = radToDeg(tangle);
                tarcData2.signedAngle = radToDeg(tsignedAngle);
                tRes.push(tarcData2);
                return (tRes);
            }
        }
        return (tRes);
    }
    getScaleFactor() {
        let tScaleFactor = null;
        if (this.mRoomManager.hoverView == null || this.mKeepMesh == null)
            return (tScaleFactor);
        tScaleFactor = Util.getViewScaleFactorOfNode(this.mRoomManager.hoverView, this.mKeepMesh, 0.1, 7);
        return (tScaleFactor);
    }
    resizeMeshes() {
        if (!this.isSelected)
            return;
        if (this.mKeepMesh == null || this.mView == null || this.mRoomManager.hoverView == null)
            return;
        updateFrozenWorldMatrix(this.mKeepMesh, true);
        resizeInViewSpace(this.mRoomManager.hoverView, this.mKeepMesh, 0.1, 10);
        this.removeAngleArcMesh();
        this.showAngleSector(this.mShowInteractor);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static deserialize(pRoomManager, pContext, pIOElement) {
        if (pIOElement == null)
            return (null);
        let tIOWall = pIOElement;
        /*
        let tWall = new Wall(pRoomManager);
        tWall.mStart.x = tIOWall.start[0];
        tWall.mStart.y = tIOWall.start[1];
        tWall.mEnd.x = tIOWall.end[0];
        tWall.mEnd.y = tIOWall.end[1];

        // abort on wall length < 0.01
        let tLength = tWall.getWallLengthBase();
        if (tLength < 0.01)
            return(null);

        tWall.setStartPoint(deserializeVector2(tIOWall.start));
        tWall.setEndPoint(deserializeVector2(tIOWall.end));
        tWall.mHeight = tIOWall.height;
        tWall.mThickness = tIOWall.thickness;
        tWall.createDummySideWalls();

        if (tIOWall.idStr != null) {
            tWall.mIdStr = tIOWall.idStr;
        }

        //material
        if (tIOWall.WallMaterialSet_A != null) {
            tWall.mMaterialA = tIOWall.WallMaterialSet_A;
        }

        if (tIOWall.WallMaterialSet_B != null) {
            tWall.mMaterialB = tIOWall.WallMaterialSet_B;
        }

        if (tIOWall.WallMaterialL_category != null) {
            tWall.mMaterialB.category = tIOWall.WallMaterialL_category;
        }

        if (tIOWall.WallMaterialL_value != null) {
            tWall.mMaterialB.value = tIOWall.WallMaterialL_value;
        }

        if (tIOWall.WallMaterialL_rotation != null) {
            tWall.mMaterialB.rotation = tIOWall.WallMaterialL_rotation;
        }

        if (tIOWall.WallMaterialL_materialNo != null) {
            let tMatId = pContext.getMaterialIdByIndex(tIOWall.WallMaterialL_materialNo);
            if (tMatId != null) {
                tWall.mMaterialB.loadMatId = tMatId;
            }
        }

        if (tIOWall.WallMaterialR_category != null) {
            tWall.mMaterialA.category = tIOWall.WallMaterialR_category;
        }

        if (tIOWall.WallMaterialR_value != null) {
            tWall.mMaterialA.value = tIOWall.WallMaterialR_value;
        }

        if (tIOWall.WallMaterialR_rotation != null) {
            tWall.mMaterialA.rotation = tIOWall.WallMaterialR_rotation;
        }

        if (tIOWall.WallMaterialR_materialNo != null) {
            let tMatId = pContext.getMaterialIdByIndex(tIOWall.WallMaterialR_materialNo);
            if (tMatId != null) {
                tWall.mMaterialA.loadMatId = tMatId;
            }
        }

        if (tIOWall.colorL != null)
            tWall.mColorL = tIOWall.colorL;
        if (tIOWall.colorR != null)
            tWall.mColorR = tIOWall.colorR;

        tWall.updateEdges();

        tWall.mRoomManager.checkMaterial(tWall.mMaterialA).then(() => {
            tWall.mRoomManager.checkMaterial(tWall.mMaterialB).then(() => {
                tWall.updateGeometry();
            });
        });

        if (tIOWall.openings != null){
            for (let tIOOpening of tIOWall.openings)
                WallOpening._load(pRoomManager,tWall, tIOOpening);
        }

        if (tIOWall.additions != null){
            for (let tIOAddition of tIOWall.additions)
                WallAddition._load(pRoomManager, pContext, tWall, tIOAddition);
        }

        pRoomManager._notifyWallLoaded(tWall, tIOWall);
        */
        let tStart = deserializeVector2(tIOWall.start);
        let tEnd = deserializeVector2(tIOWall.end);
        pRoomManager._notifyWallLoaded_deserialize(pContext, tIOWall, tStart, tEnd);
        return (null);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static deserialize_wall(pRoomManager, ploadedWalls) {
        pRoomManager.beginCollectWallUpdates();
        pRoomManager.setWallsLoading(true);
        for (let twDD of ploadedWalls) {
            let tWall = RoomWizard.createWall(pRoomManager, twDD.ioData.height, twDD.ioData.thickness);
            twDD.wall = tWall;
            tWall.setStartPoint(twDD.start);
            tWall.setEndPoint(twDD.end);
            tWall.setDrawingNew(false);
            if (twDD.ioData.idStr != null) {
                tWall.mIdStr = twDD.ioData.idStr;
            }
            if (twDD.ioData.keepVisible != null) {
                tWall.mKeepVisible = twDD.ioData.keepVisible;
            }
            //material
            if (twDD.ioData.WallMaterialSet_A != null) {
                tWall.mMaterialA = twDD.ioData.WallMaterialSet_A;
            }
            if (twDD.ioData.WallMaterialSet_B != null) {
                tWall.mMaterialB = twDD.ioData.WallMaterialSet_B;
            }
            if (twDD.ioData.WallMaterialL_category != null) {
                tWall.mMaterialB.category = twDD.ioData.WallMaterialL_category;
            }
            if (twDD.ioData.WallMaterialL_value != null) {
                tWall.mMaterialB.value = twDD.ioData.WallMaterialL_value;
            }
            if (twDD.ioData.WallMaterialL_rotation != null) {
                tWall.mMaterialB.rotation = twDD.ioData.WallMaterialL_rotation;
            }
            if (twDD.ioData.WallMaterialL_materialNo != null) {
                let tMatId = twDD.Context.getMaterialIdByIndex(twDD.ioData.WallMaterialL_materialNo);
                if (tMatId != null) {
                    tWall.mMaterialB.loadMatId = tMatId;
                }
            }
            if (twDD.ioData.WallMaterialR_category != null) {
                tWall.mMaterialA.category = twDD.ioData.WallMaterialR_category;
            }
            if (twDD.ioData.WallMaterialR_value != null) {
                tWall.mMaterialA.value = twDD.ioData.WallMaterialR_value;
            }
            if (twDD.ioData.WallMaterialR_rotation != null) {
                tWall.mMaterialA.rotation = twDD.ioData.WallMaterialR_rotation;
            }
            if (twDD.ioData.WallMaterialR_materialNo != null) {
                let tMatId = twDD.Context.getMaterialIdByIndex(twDD.ioData.WallMaterialR_materialNo);
                if (tMatId != null) {
                    tWall.mMaterialA.loadMatId = tMatId;
                }
            }
            if (twDD.ioData.colorL != null)
                tWall.mColorL = twDD.ioData.colorL;
            if (twDD.ioData.colorR != null)
                tWall.mColorR = twDD.ioData.colorR;
        }
        pRoomManager.endCollectWallUpdates(true);
        pRoomManager._findWallsConnection();
        pRoomManager.finishWallLoading(true);
    }
    static cmpWallDistance(pW1, pW2) {
        let tDist1 = 0;
        let tDist2 = 0;
        let tV;
        if (pW1 !== pW2 && Wall.gCurrentWall != null && pW1 != null && pW2 != null) {
            if (pW1.mStartCxn.wall === Wall.gCurrentWall)
                tV = pW1.mStart;
            else
                tV = pW1.mEnd;
            tDist1 = Vector2.Distance(tV, Wall.gCurrentWall.mStart);
            if (pW2.mStartCxn.wall === Wall.gCurrentWall)
                tV = pW2.mStart;
            else
                tV = pW2.mEnd;
            tDist2 = Vector2.Distance(tV, Wall.gCurrentWall.mStart);
            return (tDist1 - tDist2);
        }
        return (0);
    }
    /////
    ///// functions used to create the 2d graphic /////
    // tslint:disable-next-line:cyclomatic-complexity
    static addOpenSection(pSections, pBegin, pEnd, pIsOpening) {
        if (eq(pBegin, pEnd))
            return;
        let tNewSection = {};
        tNewSection.isOpening = pIsOpening;
        if (tNewSection.end < tNewSection.begin) {
            tNewSection.begin = pEnd;
            tNewSection.end = pBegin;
        }
        else {
            tNewSection.begin = pBegin;
            tNewSection.end = pEnd;
        }
        //merge new section with existing section
        let i = 0;
        while (i < pSections.length) {
            let tCurrent = pSections[i];
            if (leq(tNewSection.begin, tCurrent.begin) &&
                geq(tNewSection.end, tCurrent.end)) {
                pSections.splice(i, 1); //remove
                continue;
            }
            if (geq(tNewSection.begin, tCurrent.begin) &&
                leq(tNewSection.end, tCurrent.end)) {
                tNewSection.begin = tCurrent.begin;
                tNewSection.end = tCurrent.end;
                pSections.splice(i, 1); //remove
                continue;
            }
            if (leq(tNewSection.begin, tCurrent.end) &&
                geq(tNewSection.end, tCurrent.end) &&
                (geq(tNewSection.begin, tCurrent.begin))) {
                tNewSection.begin = tCurrent.begin;
                pSections.splice(i, 1); //remove
                continue;
            }
            if (leq(tNewSection.begin, tCurrent.begin) &&
                geq(tNewSection.end, tCurrent.begin) &&
                (leq(tNewSection.end, tCurrent.end))) {
                tNewSection.end = tCurrent.end;
                pSections.splice(i, 1); //remove
                continue;
            }
            ++i;
        }
        //add new section (sorted)
        for (i = 0; i < pSections.length; ++i) {
            if (leq(tNewSection.end, pSections[i].begin)) {
                pSections.splice(i + 1, 0, tNewSection); //insert
                return;
            }
        }
        pSections.push(tNewSection);
    }
    static addOpenWallSection(pSections, pWall, pSide, pVBegin, pVEnd, pIsOpening) {
        let tV = null;
        let tVStart = null;
        let tBegin = 0;
        let tEnd = 0;
        if (pSide === WallSide.Left)
            tVStart = pWall._edges[3];
        else
            tVStart = pWall._edges[0];
        let tVDir = pWall.endPoint.subtract(pWall.startPoint).normalize();
        tV = pVBegin.subtract(tVStart);
        tBegin = tV.length();
        if (Vector2.Dot(tVDir, tV.normalize()) < 0)
            tBegin = -tBegin;
        tV = pVEnd.subtract(tVStart);
        tEnd = tV.length();
        Wall.addOpenSection(pSections, tBegin, tEnd, pIsOpening);
    }
    static addWallOpenSections(pSections, pWall, pWalls, pSide, pMode) {
        let tVBegin;
        let tVEnd;
        for (let tWall of pWalls) {
            if (tWall !== pWall.mStartCxn.wall && tWall !== pWall.mEndCxn.wall) {
                if (pMode !== Line2dMode.Wall)
                    continue;
                let tAdd = false;
                if (tWall.mStartCxn.wall === pWall) {
                    if (!tWall.mStartCxn.badCut) {
                        tVBegin = tWall.mEdges[0];
                        tVEnd = tWall.mEdges[3];
                        tAdd = true;
                    }
                    // tslint:disable-next-line:no-collapsible-if
                }
                else {
                    if (!tWall.mEndCxn.badCut) {
                        tVBegin = tWall.mEdges[2];
                        tVEnd = tWall.mEdges[1];
                        tAdd = true;
                    }
                }
                if (pSide === WallSide.Left) {
                    //swap
                    let tTemp = tVBegin;
                    tVBegin = tVEnd;
                    tVEnd = tTemp;
                }
                if (tAdd)
                    Wall.addOpenWallSection(pSections, pWall, pSide, tVBegin, tVEnd, false);
            }
        }
    }
    // tslint:disable-next-line:cyclomatic-complexity
    static addOpenSectionLines(pSections, pLines, pWall, pSide) {
        let tV = null;
        let tVStart = null;
        let tVDir = pWall.endPoint.subtract(pWall.startPoint).normalize();
        if (pSide === WallSide.Left)
            tV = tVStart = pWall._edges[3];
        else
            tV = tVStart = pWall._edges[0];
        let tIsOpening = false;
        for (let tSection of pSections) {
            let tLine = {};
            tLine.p1 = tV;
            tLine.p2 = tVStart.add(tVDir.scale(tSection.begin));
            tV = tVStart.add(tVDir.scale(tSection.end));
            // tslint:disable-next-line:no-collapsible-if
            if (!Util.vectorEquals2(tLine.p1, tLine.p2)) {
                if (!(tSection === pSections[0] && tSection.isOpening &&
                    !pWall.pointOnWallSide(tLine.p2, pSide)))
                    pLines.push(tLine);
            }
            tIsOpening = tSection.isOpening;
        }
        let tLine_2d = {};
        tLine_2d.p1 = tV;
        if (pSide === WallSide.Left)
            tLine_2d.p2 = tVStart = pWall._edges[2];
        else
            tLine_2d.p2 = tVStart = pWall._edges[1];
        if (!Util.vectorEquals2(tLine_2d.p1, tLine_2d.p2) &&
            (pWall.pointOnWallSide(tV, pSide) || !tIsOpening)) {
            pLines.push(tLine_2d);
        }
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
Wall.PROP_KEY_HEIGHT = "room:Wall:height";
Wall.PROP_KEY_THICKNESS = "room:Wall:width";
Wall.PROP_KEY_KEEPVISIBLE = "room:Wall:keepVisible";
Wall.PROP_KEY_LENGTH_B = "room:Wall:lengthL";
Wall.PROP_KEY_LENGTH_A = "room:Wall:lengthR";
Wall.PROP_KEY_COLOR_B = "room:Wall:color_l";
Wall.PROP_KEY_COLOR_A = "room:Wall:color_r";
Wall.PROP_KEY_TEXROT_A = "room:Wall:textureRotation_A";
Wall.PROP_KEY_TEXROT_B = "room:Wall:textureRotation_B";
Wall.PROP_KEY_MATERIALCATEGORY_B = "room:Wall:materialCategoryL";
Wall.PROP_KEY_MATERIALCATEGORY_A = "room:Wall:materialCategoryR";
Wall.WALL_2D_HEIHGT = 0.000;
Wall.MINIMAL_WALL_LENGTH = 0.2;
Wall.WALLOPENING_FRAMEOFFSET = 0.03;
Wall.gCurrentWall = null;
//add nested types
(function (Wall) {
    let WallSnapState;
    (function (WallSnapState) {
        WallSnapState[WallSnapState["None"] = 0] = "None";
        WallSnapState[WallSnapState["Horizontal"] = 1] = "Horizontal";
        WallSnapState[WallSnapState["Vertical"] = 2] = "Vertical";
        WallSnapState[WallSnapState["Point"] = 3] = "Point";
    })(WallSnapState = Wall.WallSnapState || (Wall.WallSnapState = {}));
})(Wall || (Wall = {}));
var Line2dMode;
(function (Line2dMode) {
    Line2dMode[Line2dMode["Wall"] = 0] = "Wall";
    Line2dMode[Line2dMode["Floor"] = 1] = "Floor";
    Line2dMode[Line2dMode["Area"] = 2] = "Area";
    Line2dMode[Line2dMode["Hatch"] = 3] = "Hatch";
})(Line2dMode || (Line2dMode = {}));
//// temp variables ////////////////////////////////////////////////////////////////////////////
let gTmpVector2_1 = Vector2.Zero();
let gTmpVector3_1 = Vector3.Zero();
